import React from "react";

export const approved = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
  >
    <g fill="none" fillRule="evenodd" transform="translate(.5)">
      <circle cx="12" cy="12" r="12" fill="#8BC63F" />
      <path
        fill="#FFF"
        d="M10.327 16.75a.804.804 0 0 1-.563-.228l-3.53-3.445a.766.766 0 0 1-.001-1.102.81.81 0 0 1 1.127 0l2.967 2.896 7.063-6.893a.81.81 0 0 1 1.127 0 .766.766 0 0 1 0 1.102l-7.626 7.442a.804.804 0 0 1-.564.228"
      />
    </g>
  </svg>
);
export const manualAprovation = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
  >
    <g fill="none" fillRule="evenodd" transform="translate(.5)">
      <circle cx="12" cy="12" r="12" fill="#edce60" />
      <g fill="#FFF" transform="translate(5 10)">
        <ellipse cx="1.631" cy="1.615" rx="1.631" ry="1.615" />
        <ellipse cx="7.015" cy="1.615" rx="1.631" ry="1.615" />
        <ellipse cx="12.4" cy="1.615" rx="1.631" ry="1.615" />
      </g>
    </g>
  </svg>
);
export const awaitAValiation = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
  >
    <g fill="none" fillRule="evenodd" transform="translate(.5)">
      <circle cx="12" cy="12" r="12" fill="#858585" />
      <g fill="#FFF" transform="translate(5 10)">
        <ellipse cx="1.631" cy="1.615" rx="1.631" ry="1.615" />
        <ellipse cx="7.015" cy="1.615" rx="1.631" ry="1.615" />
        <ellipse cx="12.4" cy="1.615" rx="1.631" ry="1.615" />
      </g>
    </g>
  </svg>
);

export const awaitStage = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
  >
    <g fill="none" fillRule="evenodd" transform="translate(.5)">
      <circle cx="12" cy="12" r="12" fill="#858585" />
      <g fill="#FFF" transform="translate(5 10)">
        <ellipse cx="1.631" cy="1.615" rx="1.631" ry="1.615" />
        <ellipse cx="7.015" cy="1.615" rx="1.631" ry="1.615" />
        <ellipse cx="12.4" cy="1.615" rx="1.631" ry="1.615" />
      </g>
    </g>
  </svg>
);

export const declined = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
  >
    <g fill="none" fillRule="evenodd" transform="translate(.5)">
      <circle cx="12" cy="12" r="12" fill="#FF586D" />
      <path
        fill="#FFF"
        d="M13.146 13.613h-1.664L11.16 7h2.306l-.321 6.613zM12.314 17h-.015C11.526 17 11 16.43 11 15.672c0-.789.54-1.329 1.314-1.329s1.285.54 1.3 1.329c0 .759-.512 1.328-1.3 1.328z"
      />
    </g>
  </svg>
);

export const evaluate = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
  >
    <g fill="none" fillRule="evenodd" transform="translate(.5)">
      <circle cx="12" cy="12" r="12" fill="#005394" />
      <g fill="#FFF" transform="translate(5 10)">
        <ellipse cx="1.631" cy="1.615" rx="1.631" ry="1.615" />
        <ellipse cx="7.015" cy="1.615" rx="1.631" ry="1.615" />
        <ellipse cx="12.4" cy="1.615" rx="1.631" ry="1.615" />
      </g>
    </g>
  </svg>
);

export const arrowColapse = () => (
  <svg width="31px" height="30px" viewBox="0 0 31 30" version="1.1">
    <g
      id="[S5]-Gerenciar-candidatos"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="#5.2-Candidato" transform="translate(-1354.000000, -698.000000)">
        <g
          id="elements/number-card-copy-6"
          transform="translate(266.000000, 683.000000)"
        >
          <g id="Group-18" transform="translate(0.500000, 0.000000)">
            <g id="Group-20" transform="translate(1087.400000, 14.500000)">
              <rect
                id="Rectangle"
                fill="#FFFFFF"
                x="0.6"
                y="0.5"
                width="30"
                height="30"
              />
              <polyline
                id="Shape"
                stroke="#005394"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
                points="6 11 15.6 20 25.2 11"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const aboutBtnIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g fill="#17B3D2" fillRule="evenodd">
      <path d="M12.396 13.235c3.38 0 6.122-2.733 6.122-6.103 0-3.37-2.741-6.085-6.122-6.085-3.379 0-6.12 2.733-6.12 6.085 0 3.351 2.741 6.103 6.12 6.103zm0-10.596c2.48 0 4.507 2.022 4.507 4.493 0 2.471-2.028 4.493-4.507 4.493-2.478 0-4.506-2.022-4.506-4.493 0-2.471 2.028-4.493 4.506-4.493zM1.808 22.766H23.06a.8.8 0 0 0 .808-.805c0-4.213-3.436-7.658-7.68-7.658H8.68C4.454 14.303 1 17.73 1 21.961a.8.8 0 0 0 .808.805zm6.87-6.853h7.511a6.055 6.055 0 0 1 6.009 5.243H2.67a6.07 6.07 0 0 1 6.008-5.243z" />
    </g>
  </svg>
);

export const carrierBtnIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g fill="#17B3D2" fillRule="nonzero">
      <path d="M17.315 1.412h5.315c.367 0 .664.297.664.664v19.267a.664.664 0 0 1-.664.664h-5.315a.664.664 0 0 1-.664-.664V2.076c0-.367.297-.664.664-.664zm.664 1.328v17.938h3.986V2.74H17.98zM9.343 5.398h5.314c.367 0 .665.297.665.664v15.28a.664.664 0 0 1-.665.665H9.343a.664.664 0 0 1-.665-.664V6.063c0-.368.298-.665.665-.665zm.664 1.329v13.951h3.986V6.727h-3.986zM5.388 12.996a3.322 3.322 0 0 1 1.961 3.032v5.315a.664.664 0 0 1-.664.664H1.37a.664.664 0 0 1-.664-.664v-5.315c0-1.35.805-2.512 1.961-3.032a2.657 2.657 0 1 1 2.72 0zm.633 7.682v-4.65a1.993 1.993 0 1 0-3.986 0v4.65H6.02zm-1.993-8.636a1.329 1.329 0 1 0 0-2.658 1.329 1.329 0 0 0 0 2.658z" />
    </g>
  </svg>
);

export const formationBtnIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      fill="#17B3D2"
      fillRule="nonzero"
      d="M16.235 15.248a8.081 8.081 0 0 1-3.882.987 8.081 8.081 0 0 1-3.882-.987v7.084l3.356-3.75a.706.706 0 0 1 1.052 0l3.356 3.75v-7.084zm1.412-.976v8.06a1.412 1.412 0 0 1-2.464.942l-2.83-3.163-2.83 3.163a1.412 1.412 0 0 1-2.464-.942v-8.06a8.118 8.118 0 1 1 10.588 0zm-5.294.552a6.706 6.706 0 1 0 0-13.412 6.706 6.706 0 0 0 0 13.412z"
    />
  </svg>
);

export const goalBtnIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      fill="#17B3D2"
      fillRule="nonzero"
      d="M5.783 5.291a10.292 10.292 0 0 1 7.185-2.91c5.703 0 10.326 4.623 10.326 10.326s-4.623 10.326-10.326 10.326c-5.702 0-10.325-4.623-10.325-10.326 0-1.459.303-2.876.882-4.182a.558.558 0 1 1 1.02.453 9.175 9.175 0 0 0-.786 3.73 9.21 9.21 0 1 0 9.21-9.21c-2.42 0-4.69.936-6.396 2.583L9.12 8.629a5.741 5.741 0 0 1 3.568-1.224c3.076 0 5.582 2.366 5.582 5.302 0 2.936-2.506 5.303-5.582 5.303-3.075 0-5.581-2.367-5.581-5.303a.558.558 0 1 1 1.116 0c0 2.305 1.992 4.186 4.465 4.186s4.465-1.881 4.465-4.186c0-2.304-1.992-4.186-4.465-4.186a4.634 4.634 0 0 0-2.771.904l2.482 2.483a1.118 1.118 0 0 1 1.406 1.078 1.116 1.116 0 1 1-2.195-.289L3.129 4.215h-.715a.558.558 0 0 1-.403-.171L.863 2.848a.558.558 0 0 1 .402-.945h.59v-.638c0-.51.63-.753.972-.375l1.084 1.196a.558.558 0 0 1 .145.375v1.103L5.783 5.29z"
    />
  </svg>
);

export const attachBtnIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      fill="#17B3D2"
      fillRule="nonzero"
      stroke="#17B3D2"
      strokeWidth=".5"
      d="M22.642 2.955a4.567 4.567 0 0 0-6.53-.002L4.963 14.356a2.616 2.616 0 0 0 0 3.659 2.46 2.46 0 0 0 3.536.002l6.91-7.086a.419.419 0 0 0 0-.615c-.168-.171-.38-.171-.55.002l-6.96 7.027c-.647.659-1.741.659-2.39 0a1.714 1.714 0 0 1 0-2.373L16.658 3.57c1.464-1.49 3.919-1.49 5.382 0 1.452 1.478 1.453 3.94.001 5.416L10.891 20.39c-2.336 2.376-6.1 2.376-8.374 0-2.323-2.365-2.323-6.16 0-8.462L12.525 1.743a.419.419 0 0 0 0-.615c-.168-.171-.379-.17-.548.001L1.97 11.257c-2.627 2.673-2.627 7.074 0 9.747a6.675 6.675 0 0 0 9.522 0l11.15-11.346c1.81-1.843 1.81-4.86 0-6.703z"
    />
  </svg>
);

export const iconDoor = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="19"
    viewBox="0 0 12 19"
  >
    <path
      fill="#858585"
      fillRule="nonzero"
      d="M10.65.594H.6a.464.464 0 0 0-.469.469v16.875c0 .262.207.468.469.468h10.05a.464.464 0 0 0 .469-.468V1.063a.464.464 0 0 0-.469-.47zm-.525 16.8H2.437L6.112 15.5c.02 0 .02-.019.038-.019a.57.57 0 0 0 .15-.15l.056-.112c.019-.056.019-.094.019-.131V3.912a.498.498 0 0 0-.263-.432L2.42 1.606h7.687v15.788h.019zM4.781 9.8v-.619a.356.356 0 1 1 .713 0V9.8a.356.356 0 0 1-.356.356c-.207.019-.357-.15-.357-.356z"
    />
  </svg>
);

export const userGreenIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="18"
    viewBox="0 0 19 18"
  >
    <g fill="#8BC63F" fillRule="evenodd">
      <path d="M9.324 10.01c2.766 0 5.009-2.236 5.009-4.993S12.09.038 9.324.038c-2.765 0-5.007 2.237-5.007 4.979s2.242 4.994 5.007 4.994zm0-8.67c2.029 0 3.688 1.655 3.688 3.677 0 2.022-1.66 3.676-3.688 3.676-2.027 0-3.686-1.654-3.686-3.676 0-2.022 1.659-3.676 3.686-3.676zM.66 17.809h17.39c.37 0 .66-.291.66-.66 0-3.446-2.81-6.265-6.283-6.265H6.283C2.826 10.884 0 13.688 0 17.15c0 .368.292.659.66.659zm5.623-5.607h6.144c2.52 0 4.594 1.869 4.916 4.29H1.367a4.967 4.967 0 0 1 4.916-4.29z" />
    </g>
  </svg>
);

export const avatarIcon_ = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 36 36"
    xmlSpace="preserve">
    <style type="text/css"></style>
    <g>
      <g id="Camada_8">
        <path
          fill="#005156"
          d="M26.7,19.9c-1.5-1.7-3.3-2.7-5.6-3.3c1.5-1.2,2.7-2.6,2.9-4.5c0.2-1.9-0.4-3.7-1.8-5
        c-2.5-2.4-6.3-2.3-8.7,0.3c-2,2.2-2.7,6.1,1.4,9.3c-4.7,1.2-7.7,4.7-8,9.4c-0.1,1.1,0.3,1.5,1.4,1.5h19.3c0.1,0,0.3,0,0.4,0
        c0.7-0.1,1.1-0.4,1.1-1.1C29.2,24,28.4,21.8,26.7,19.9z M13,11.3c0.1-2.9,2.3-5,5.2-5c2.8,0.1,5,2.3,4.9,5.1
        c-0.1,2.8-2.4,5.1-5.1,5C15.2,16.5,13,14.1,13,11.3z M27.6,26.6c-3.2,0-6.3,0-9.5,0s-6.4,0-9.6,0c-0.4,0-0.5-0.1-0.5-0.5
        c0.2-4.1,3.5-7.9,7.5-8.4c2.3-0.3,4.8-0.5,7.1,0.5c3.4,1.5,5.3,4.1,5.7,7.9C28.2,26.5,28.1,26.6,27.6,26.6z"
        />
      </g>
      <ellipse
        class="st1"
        fill="none"
        stroke="#005156"
        strokeMiterlimit="10"
        cx="18"
        cy="17.3"
        rx="16.9"
        ry="16.5"
      />
    </g>
  </svg>
);

export const plugAec = (props) => (
  <svg
    id="Camada_1"
    data-name="Camada 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 192.02 217.34"
  >
    <defs>
      <style>
        {
          ".cls-1{fill:#1872c5;}.cls-2{fill:#0a68be;}.cls-3,.cls-9{fill:#005156;}.cls-4{fill:#fff;}.cls-5{fill:#0e6dc1;}.cls-6{fill:#f2f6f9;}.cls-7{fill:#0f6ec1;}.cls-8{fill:#fdfdfd;}.cls-9{stroke:#000;stroke-miterlimit:10;}.cls-10{fill:#0061bc;}.cls-11{fill:#64bcf9;}.cls-12{fill:#1472c3;}"
        }
      </style>
    </defs>
    <path class="cls-1" d="M149.9,191.23" transform="translate(-29.71 -14)" />
    <path class="cls-1" d="M154.61,188.87" transform="translate(-29.71 -14)" />
    <path class="cls-1" d="M154.61,188.87" transform="translate(-29.71 -14)" />
    <path class="cls-1" d="M171.09,200.65" transform="translate(-29.71 -14)" />
    <path class="cls-2" d="M161.67,214.78" transform="translate(-29.71 -14)" />
    <path class="cls-1" d="M158.14,212.42" transform="translate(-29.71 -14)" />
    <path class="cls-1" d="M159.32,187.69" transform="translate(-29.71 -14)" />
    <path class="cls-1" d="M162.85,207.71" transform="translate(-29.71 -14)" />
    <path class="cls-1" d="M154.61,124.1" transform="translate(-29.71 -14)" />
    <path class="cls-1" d="M148.72,187.69" transform="translate(-29.71 -14)" />
    <ellipse class="cls-3" cx="96.04" cy="101.27" rx="84.2" ry="83.02" />
    <path class="cls-1" d="M127.52,181.8" transform="translate(-29.71 -14)" />
    <path class="cls-1" d="M127.52,181.8" transform="translate(-29.71 -14)" />
    <path class="cls-4" d="M129.88,181.8" transform="translate(-29.71 -14)" />
    <path
      class="cls-3"
      d="M209.72,159.67c-.16.35-.25.62-.39.86-1.25,2.21-2.51,4.41-3.77,6.62-.27.47-.54.81-1.14.38a.91.91,0,0,1-.29-1.44c1.29-2.18,2.53-4.4,3.79-6.6.22-.39.44-.81,1-.48C209.16,159.2,209.41,159.43,209.72,159.67Z"
      transform="translate(-29.71 -14)"
    />
    <path
      class="cls-3"
      d="M212.07,153.89c-.43-.26-1.26-.26-.85-1.27,1-2.45,2-4.88,2.9-7.35.24-.64.55-.78,1.1-.51.37.17.83.3.59.92-1,2.58-2,5.17-3.07,7.75C212.63,153.69,212.48,154,212.07,153.89Z"
      transform="translate(-29.71 -14)"
    />
    <path
      class="cls-3"
      d="M217.61,139.13c-.75-.18-1.38-.31-1.19-1.14.62-2.65,1.29-5.29,1.92-7.94.13-.53.33-.75.86-.49.34.16,1,0,.81.68q-1,4.2-2,8.38C218,138.89,217.76,139.15,217.61,139.13Z"
      transform="translate(-29.71 -14)"
    />
    <path
      class="cls-3"
      d="M218.84,96.94c.06.23.14.51.21.79.6,2.42,1.18,4.84,1.8,7.26.17.68.15,1.09-.64,1.25s-.91-.13-1.07-.83c-.57-2.51-1.22-5-1.82-7.49-.09-.38-.36-.85.31-1C218,96.79,218.4,96.54,218.84,96.94Z"
      transform="translate(-29.71 -14)"
    />
    <path
      class="cls-3"
      d="M182.11,41.79c.38-.34.53-1.38,1.39-.62l5.95,5.26c.36.32.56.62.08,1-.32.29-.59.81-1,.44-2.11-1.82-4.18-3.7-6.26-5.56C182.1,42.23,181.9,42.08,182.11,41.79Z"
      transform="translate(-29.71 -14)"
    />
    <path
      class="cls-3"
      d="M197.25,54.64c1.2,1.51,2.56,3.19,3.87,4.9.45.59.83,1.27,0,1.87s-1-.39-1.34-.81c-1.32-1.62-2.63-3.24-3.9-4.9-.35-.47-1.5-.7-.65-1.67S196.55,54,197.25,54.64Z"
      transform="translate(-29.71 -14)"
    />
    <path
      class="cls-3"
      d="M213.45,82.13c.44,1,.89,2,1.3,3q.93,2.34,1.81,4.71c.18.49.32,1-.41,1.19-.46.13-.86.2-1.07-.3C214,88.18,213,85.6,212,83a.57.57,0,0,1,.38-.84C212.69,82.07,213.05,81.65,213.45,82.13Z"
      transform="translate(-29.71 -14)"
    />
    <path
      class="cls-3"
      d="M221.62,113c.06.81.12,1.1.1,1.38-.17,2.59-.36,5.17-.55,7.75,0,.59-.19,1-.88.88s-.86-.34-.81-1q.32-4,.57-8c0-.41.11-.69.56-.75A8.35,8.35,0,0,0,221.62,113Z"
      transform="translate(-29.71 -14)"
    />
    <path
      class="cls-3"
      d="M209.58,74.26c-.65.63-1.07.37-1.48-.35-1.18-2.08-2.41-4.13-3.58-6.21-.27-.47-.7-1,0-1.53s1.08-.08,1.44.56c1.17,2.08,2.38,4.14,3.59,6.21C209.82,73.39,210.16,73.8,209.58,74.26Z"
      transform="translate(-29.71 -14)"
    />
    <path
      class="cls-3"
      d="M45.78,165.93c.18.33.29.6.44.83q2.09,3.18,4.19,6.35c.3.45.6.78,1.17.31a.91.91,0,0,0,.19-1.45c-1.43-2.1-2.81-4.23-4.21-6.35-.24-.37-.49-.77-1-.4C46.31,165.42,46.07,165.67,45.78,165.93Z"
      transform="translate(-29.71 -14)"
    />
    <path
      class="cls-3"
      d="M43.05,160.31c.41-.29,1.24-.34.77-1.32-1.14-2.38-2.28-4.74-3.38-7.14-.28-.63-.6-.74-1.13-.45-.36.21-.81.36-.53,1l3.57,7.53C42.48,160.15,42.65,160.41,43.05,160.31Z"
      transform="translate(-29.71 -14)"
    />
    <path
      class="cls-3"
      d="M36.56,145.94c.73-.22,1.35-.39,1.11-1.2-.79-2.61-1.63-5.2-2.44-7.8-.16-.53-.38-.73-.89-.44-.32.19-1,0-.76.73.82,2.76,1.68,5.5,2.54,8.24C36.2,145.73,36.4,146,36.56,145.94Z"
      transform="translate(-29.71 -14)"
    />
    <path
      class="cls-3"
      d="M31,103.94c0,.23-.1.52-.15.81-.35,2.47-.69,5-1.07,7.43-.11.69,0,1.1.86,1.16s1-.24,1.08-1c.31-2.56.72-5.1,1.07-7.65.05-.39.29-.9-.47-1C31.84,103.69,31.39,103.48,31,103.94Z"
      transform="translate(-29.71 -14)"
    />
    <path
      class="cls-3"
      d="M64.33,44.7c-.41-.31-.62-1.33-1.43-.52Q60.1,47,57.31,49.81c-.34.35-.52.66,0,1.06.33.26.64.77,1,.37,2-2,3.93-4,5.89-6C64.36,45.14,64.56,45,64.33,44.7Z"
      transform="translate(-29.71 -14)"
    />
    <path
      class="cls-3"
      d="M50.06,58.52c-1.1,1.59-2.34,3.35-3.54,5.15-.4.61-.75,1.31.15,1.86s1-.46,1.28-.9c1.21-1.7,2.41-3.41,3.57-5.15.32-.48,1.45-.79.53-1.71S50.72,57.79,50.06,58.52Z"
      transform="translate(-29.71 -14)"
    />
    <path
      class="cls-3"
      d="M35.7,87c-.37,1-.76,2-1.1,3.09-.52,1.59-1,3.2-1.49,4.81-.15.5-.26,1,.48,1.16.47.11.87.14,1-.36.88-2.63,1.74-5.26,2.61-7.89a.56.56,0,0,0-.42-.81C36.46,86.91,36.07,86.51,35.7,87Z"
      transform="translate(-29.71 -14)"
    />
    <path
      class="cls-3"
      d="M30.47,120.18a13.77,13.77,0,0,0,0,1.38c.38,2.57.79,5.13,1.17,7.7.09.59.29,1,1.05.81s.93-.38.82-1q-.63-4-1.21-7.92c-.06-.41-.17-.68-.67-.71A10,10,0,0,1,30.47,120.18Z"
      transform="translate(-29.71 -14)"
    />
    <path
      class="cls-3"
      d="M39.05,78.91c.68.59,1.09.3,1.45-.45,1-2.15,2.13-4.28,3.17-6.43.23-.49.62-1-.12-1.53s-1.08,0-1.39.65c-1,2.16-2.11,4.3-3.18,6.44C38.75,78.05,38.44,78.49,39.05,78.91Z"
      transform="translate(-29.71 -14)"
    />
    <path
      d="M161.09,14H88.65A11.75,11.75,0,0,0,76.89,25.76V120a11.76,11.76,0,0,0,11.76,11.77h72.44A11.77,11.77,0,0,0,172.86,120V25.76A11.76,11.76,0,0,0,161.09,14Zm5.42,111.16a6.6,6.6,0,0,1-4.59.89c-6.71-.64-67.29-.32-72.27-.31a7.56,7.56,0,0,1-5.06-1.45c-2.28-1.93-2.12-5.31-2-9.07.09-4.8-.31-9.62,0-14.43.08-1.39,0-6.86,0-17.78-.11-18.53,1-37.07-.07-55.57-.09-1.62-.4-6.07,2.38-8.19,2.11-1.62,5.06-1,6.18-1,19.12.09,38.23.33,57.35.25,1.07,0,3.84-.19,5,1.37.62.79.56,1.65.56,7.65,0,2.45.24,3,.68,3.44.87.93,2.1.74,6,.84,5.43.14,6.33.59,6.9,1.1,1.46,1.36,1.21,3.7,1.15,4.45-.61,7.45-.06,64.07.1,81.13C168.81,119.72,168.9,123.42,166.51,125.16Z"
      transform="translate(-29.71 -14)"
    />
    <path
      class="cls-5"
      d="M82.08,87.17s0,0-.06.08v-.13Z"
      transform="translate(-29.71 -14)"
    />
    <path
      class="cls-6"
      d="M82.43,85.42v.13a.19.19,0,0,0,.06-.07Z"
      transform="translate(-29.71 -14)"
    />
    <path
      class="cls-4"
      d="M166.51,125.16a6.6,6.6,0,0,1-4.59.89c-6.71-.64-67.29-.32-72.27-.31a7.56,7.56,0,0,1-5.06-1.45c-2.28-1.93-2.12-5.31-2-9.07.09-4.8-.31-9.62,0-14.43.08-1.39,0-6.86,0-17.78-.11-18.53,1-37.07-.07-55.57-.09-1.62-.4-6.07,2.38-8.19,2.11-1.62,5.06-1,6.18-1,19.12.09,38.23.33,57.35.25,1.07,0,3.84-.19,5,1.37.62.79.56,1.65.56,7.65,0,2.45.24,3,.68,3.44.87.93,2.1.74,6,.84,5.43.14,6.33.59,6.9,1.1,1.46,1.36,1.21,3.7,1.15,4.45-.61,7.45-.06,64.07.1,81.13C168.81,119.72,168.9,123.42,166.51,125.16Z"
      transform="translate(-29.71 -14)"
    />
    <path
      class="cls-7"
      d="M82.08,87.17s0,0-.06.08v-.13Z"
      transform="translate(-29.71 -14)"
    />
    <path
      class="cls-8"
      d="M82,87.12v.13s0,0,.06-.08Z"
      transform="translate(-29.71 -14)"
    />
    <path class="cls-6" d="M191.11,31.07" transform="translate(-29.71 -14)" />
    <path
      d="M201,174.23q-11.14-19.23-22.24-38.5c-1.51-2.59-2.38-2.77-5.08-1.22-4.53,2.62-9,5.34-13.58,7.87-2.11,1.17-3.73,2.35-2.32,5.29-2.21,0-4.1,0-6,0-8.1-.11-16.21-.46-24.31-.29-6.72.16-13,1.71-17.08,7.92A1.72,1.72,0,0,1,109,156a32.38,32.38,0,0,1-11-5.61c2.1-4.5,2.07-4.53-2-6.86-4.55-2.6-9.09-5.19-13.6-7.84-1.92-1.11-3.21-.74-4.29,1.19-2.4,4.27-4.89,8.46-7.34,12.69q-7.59,13.14-15.19,26.28c-.9,1.54-1.14,3,.65,4,5.35,3.12,10.72,6.2,16.08,9.3,1.58.91,2.81.5,3.73-1.07a11.77,11.77,0,0,1,1.12-1.39c.66.74,1.14,1.37,1.7,1.91,1.59,1.51,2.47,2.85,1.29,5.34a7,7,0,0,0,2.91,8.92,28.05,28.05,0,0,0,5.07,1.94c.11,6.57,2.82,9.22,9.82,9.41,1.73,7.14,2.7,7.95,10.44,8.7.11.67.22,1.36.37,2,1.35,5.79,8.35,8.39,12.74,4.46,2.37-2.11,4.6-2.8,7.52-2a20.52,20.52,0,0,0,2.84.47c7.39.92,9.2-.18,11.39-6.43a8.8,8.8,0,0,0,9-2.06,9.11,9.11,0,0,0,2.34-7.62,8.24,8.24,0,0,0,7.08-1.8,7.87,7.87,0,0,0,2.11-8.06,1.53,1.53,0,0,1,.48-.14c5.54.55,6.3-.78,7.77-1.75,2.32-1.56,2.85-5.44,2.59-7.72-.15-1.38-.55-1.62-.35-2.49.39-1.73,2.3-2.77,3.89-3.4a3.27,3.27,0,0,1,2.35,0c1,.48,1.09,1.39,1.89,1.71,1.14.45,2.55-.87,3.24-1.26,4.68-2.67,9.32-5.45,14.07-8.05C201.9,177.71,202.23,176.33,201,174.23ZM74.53,183a14.13,14.13,0,0,1-9.42-9.42q8.25-15.3,16.49-30.62a11.16,11.16,0,0,1,5.88,1.18,11,11,0,0,1,4.71,4.71q-4.43,9.24-9.42,18.84C80,172.93,77.28,178,74.53,183Zm11.22,17.56a4.83,4.83,0,0,1-1.42-1.43,1.73,1.73,0,0,1-.19-.31.48.48,0,0,1-.09-.19,1.51,1.51,0,0,1-.09-.18c-.06-.12-.09-.25-.13-.35a1.27,1.27,0,0,1-.1-.37c0-.16-.07-.33-.1-.5a5.12,5.12,0,0,1,0-.56c0-.13,0-.26,0-.37a.71.71,0,0,0,0-.14.25.25,0,0,1,0-.13,1.38,1.38,0,0,1,0-.22c0-.09,0-.18,0-.25a3.6,3.6,0,0,1,.12-.44c.9-2.77,5.42-6.43,9.19-6.44a14.52,14.52,0,0,1,3.29,3,3,3,0,0,1,.37.73,1.54,1.54,0,0,1,.08.19.27.27,0,0,1,0,.13,3.38,3.38,0,0,1,.11.48,4.78,4.78,0,0,1-1.51,4,26.08,26.08,0,0,1-4,3.38A4.74,4.74,0,0,1,85.75,200.54Zm11.17,10.73h-.31l-.42-.06-.25,0a4.79,4.79,0,0,1-1.54-.71,1.07,1.07,0,0,1-.19-.13,6,6,0,0,1-.79-.73c-1.93-2.2-1.66-5.18.82-7.39,1.72-1.54,3.47-3.05,5.21-4.56s3.51-3,5.26-4.5a4.87,4.87,0,0,1,4-1.34,3.7,3.7,0,0,1,1.49.68l.19.14c1.93,1.58,1.91,4.5,1.9,5a13.89,13.89,0,0,1-1,3.15c-1.83,4.17-5.71,5.11-10.7,9.18A5.45,5.45,0,0,1,96.92,211.27Zm14.21,7a6.23,6.23,0,0,1-4.57,1.66,4.87,4.87,0,0,1-1-.22s0,0,0,0a4.28,4.28,0,0,1-.91-.45,4.81,4.81,0,0,1-.85-.67c-.13-.13-.26-.26-.39-.41-2-2.28-1.66-5.16,1-7.59s5.51-4.83,8.35-7.13c.13-.1.24-.2.37-.29a4.53,4.53,0,0,1,.4-.26l.19-.11.17-.09.29-.14.37-.14a3.7,3.7,0,0,1,.87-.22,1.45,1.45,0,0,1,.29,0,4,4,0,0,1,.77,0l.4.06a4.73,4.73,0,0,1,1.46.71,12.19,12.19,0,0,1,2.42,2.88l.1.15,0,.08a2.51,2.51,0,0,1,.18,2.11l0,.09s0,0,0,0a1,1,0,0,1-.12.26c-.29.51-.55,1-.8,1.41l-.07.11a6.8,6.8,0,0,1-1,1.28l-.06.06c-2.42,2.33-5,4.47-7.62,6.6Zm15.21,3.85a26.63,26.63,0,0,1-6.47,5.55,4.7,4.7,0,0,1-6.41-1.51,5,5,0,0,1-.46-.86,5.39,5.39,0,0,1-.39-2.11,5.2,5.2,0,0,1,.84-2.45,9.46,9.46,0,0,1,.78-1.12c.29-.37.61-.74,1-1.1,2.34-2.46,5.76-4.53,7.9-4.21C126.67,214.89,128.7,219.39,126.34,222.16Zm42-23a3.75,3.75,0,0,1-.79-.09,18.53,18.53,0,0,1-6.26-2.34c-5.82-3.51-11.47-7.3-17.27-10.86a1.74,1.74,0,0,0-.76-.23s0,0,0,0l-.22,0c-.61,0-1.3,0-1.9,0,.47.88.7,2.09,1.44,2.59,5.44,3.61,11,7.09,16.5,10.58,2.73,1.75,3.29,3.81,1.76,6.81a5.52,5.52,0,0,1-4.37,3.31,4.94,4.94,0,0,1-.86,0l-.37-.06a5.69,5.69,0,0,1-1.33-.46c-2.58-1.27-5-2.83-7.49-4.29-3.45-2-6.84-4.19-10.35-6.13a2,2,0,0,0-.67-.22l-.28,0c-.64-.05-1.36.05-2,0,.51.93.8,2.24,1.57,2.73,4.81,3,9.67,5.92,14.63,8.67,2.31,1.27,2.6,3.09,2.25,5.26a4,4,0,0,1-4.3,3.45,10.72,10.72,0,0,1-1.57-.16,14,14,0,0,1-2.92-.93l-2.13-1c-2.07-1-4.11-2.06-6.17-3.1l-.14-.07-.42-.22a3.75,3.75,0,0,0-.44-.24,3.12,3.12,0,0,0-.86-.32c-.5-.08-1,.11-1.31.91-.2.47.73,1.72,1.49,2.25a.44.44,0,0,0,.15.1c1.93,1.18,4,2,6,3.08a18,18,0,0,1,1.78.82s0,0,0,0a1.64,1.64,0,0,1,.56,1.93c-.5,2.18-1.26,4.24-3.85,4.25-2.35,0-4.72-.27-7.26-.51h-.13c-.47,0-1-.07-1.43-.12,2.26-5,1.93-8.38-1.1-11a3.52,3.52,0,0,0-.55-.43c-1.11-.61-2.14.27-3-.13-.39-.18-.83-.66-1-2a7.84,7.84,0,0,0,1-5,7.51,7.51,0,0,0-1.22-3.1c-2.13-3.21-6-3.8-6.83-3.9.38-3.88-.57-7.27-4.36-9.19a7.38,7.38,0,0,0-4.78-.81,6.88,6.88,0,0,0-1.39.4,17.5,17.5,0,0,0-5.44,4c-.13-.58-.28-1.12-.45-1.64-.09-.28-.19-.56-.29-.82l-.11-.25a9,9,0,0,0-1-1.81c-.13-.18-.27-.34-.39-.5L97.4,188a5.76,5.76,0,0,0-1.2-1l-.45-.28h0a8.26,8.26,0,0,0-2.11-.8,7.51,7.51,0,0,0-4.41.23c-.32.12-.63.25-.94.4h0a14.64,14.64,0,0,0-2.92,2.05.75.75,0,0,1-.2.18,1.2,1.2,0,0,1-1.33-.17,1.24,1.24,0,0,1-.19-.21c-1.19-1.33-2.35-2.61-3.42-3.95a1.78,1.78,0,0,1,0-1.61c5.56-9.69,11.15-19.33,16.8-29.09.07-.13.16-.26.23-.39l0,0h0c.15.07.28.15.42.2l10.26,5.08.25.12c.25.13.49.23.72.36-1.48,2-3,4-4.46,6a7.59,7.59,0,0,0-1.37,3.63c0,.22,0,.43,0,.66a3,3,0,0,0,0,.67,7.34,7.34,0,0,0,2.82,5,9.53,9.53,0,0,0,12.28.16,97.13,97.13,0,0,0,7.48-7.3c4.12-4.3,5.11-4.71,10.26-1.66,5.54,3.28,10.84,7,16.15,10.62,5.62,3.85,11.1,7.87,16.66,11.78a6.8,6.8,0,0,1,3.12,7c-.07.49-.61,2.79-2.36,3.38A2.8,2.8,0,0,1,168.3,199.2Zm9.32-16.1a52.83,52.83,0,0,1-4.57,5c-10.14-7.08-19.89-14-29.73-20.74-.64-.45-1.3-.88-2-1.29s-1.34-.81-2-1.2-1.36-.76-2.06-1.14-1.38-.74-2.07-1.12c-3.73-2-6.38-1.68-9.5,1.26s-5.83,5.76-8.73,8.66a6.82,6.82,0,0,1-2.14,1.48,6.61,6.61,0,0,1-4.23.23l-.64-.17c-3.83-1.18-5-4.71-2.7-7.93s4.86-6.59,7.27-9.9a12,12,0,0,1,9-5.28c2.86-.22,5.74-.42,8.61-.58,1.44-.09,2.86-.16,4.3-.21s2.87-.08,4.31-.09c3.3,0,6.59.06,9.9.18h.12c1.4,0,2.8.12,4.2.19s2.89.13,4.34.2a3.39,3.39,0,0,1,2.42,1.37q8.16,13.88,16.08,27.88A3.63,3.63,0,0,1,177.62,183.1Zm22.1-7.08c-1.31.77-2.62,1.52-3.91,2.26l-11.65,6.77-22.74-39.39,11.6-6.75,3.94-2.3c3.81,6.62,7.6,13.15,11.37,19.7s7.56,13.08,11.39,19.7Z"
      transform="translate(-29.71 -14)"
    />
    <path
      class="cls-3"
      d="M96.47,147.63q-5.49,8.55-11,17.88Q79.29,176,74,186.06l-15-8,22.85-39.37c1.22.71,2.45,1.44,3.67,2.17Q91.11,144.24,96.47,147.63Z"
      transform="translate(-29.71 -14)"
    />
    <path
      class="cls-4"
      d="M129.31,223a7.33,7.33,0,0,0,.69-4c-.06-1.62-.1-2.85-1-4s-2.72-2.28-4-2a1.73,1.73,0,0,1-1,0,1.93,1.93,0,0,1-1-1c-.67-1.39.89-2.58,1-5a6.67,6.67,0,0,0-1.27-4.08,8,8,0,0,0-2.9-2.27,15.27,15.27,0,0,0-2.93-1.31A1.42,1.42,0,0,1,116,198c.12-3.45-1-6.42-4.43-8.18a8.19,8.19,0,0,0-3.81-.92c-4.35.22-7,5.81-8.06,5.19-.43-.24.15-1-.37-2.77a8.22,8.22,0,0,0-2.55-3.84l-.13-.11a8.33,8.33,0,0,0-5.76-1.64c-3.34.41-4,3.36-6.3,3.15-1.34-.13-2.36-1.24-3.13-2.09a5.05,5.05,0,0,1-1.35-2.35,1.79,1.79,0,0,1,0-1.6c5.43-9.5,10.9-19,16.42-28.55a1.39,1.39,0,0,1,1.83-.55l9,4.47a1.41,1.41,0,0,1,.51,2.1c-1.17,1.56-2.35,3.12-3.47,4.72a7.2,7.2,0,0,0,1.44,10,9.52,9.52,0,0,0,12.31.17,94.28,94.28,0,0,0,7.5-7.33c4.13-4.33,5.13-4.74,10.28-1.67,5.55,3.3,10.87,7,16.2,10.67,5.62,3.87,11.12,7.9,16.7,11.83a7.66,7.66,0,0,1,2.75,3.33,6.72,6.72,0,0,1,.29,4.07,4.1,4.1,0,0,1-1.55,2.69,3.66,3.66,0,0,1-2.69.38,19.11,19.11,0,0,1-6.28-2.36c-5.83-3.53-11.5-7.34-17.3-10.92l-.2-.1a1.4,1.4,0,0,0-1.47,2.29,1.56,1.56,0,0,0,.2.16c5.46,3.64,11,7.13,16.54,10.65,2.74,1.75,3.29,3.82,1.76,6.83s-4.2,4.14-6.94,2.79c-2.58-1.28-5-2.84-7.51-4.31-3.45-2.06-6.85-4.22-10.37-6.16a1.55,1.55,0,0,0-.44-.17A1.39,1.39,0,0,0,134.1,200a2,2,0,0,0,.52.53c4.82,3,9.69,6,14.66,8.71,2.31,1.28,2.6,3.12,2.25,5.29a4,4,0,0,1-4.3,3.47,11.68,11.68,0,0,1-4.5-1.1c-2.88-1.27-5.65-2.77-8.46-4.18-1.08-.54-2.35-1.54-3,.14-.21.5.85,1.89,1.63,2.37,1.93,1.17,4.06,2,6.07,3.08,1.12.6,2.87.7,2.39,2.8a6.2,6.2,0,0,1-2.07,3.81A5.87,5.87,0,0,1,137,226c-1.08.3-1.84.23-4,0-4.21-.45-4.88-.56-5-1S128.63,224.25,129.31,223Z"
      transform="translate(-29.71 -14)"
    />
    <path class="cls-4" d="M149,227" transform="translate(-29.71 -14)" />
    <path class="cls-4" d="M151,230" transform="translate(-29.71 -14)" />
    <path
      class="cls-4"
      d="M173.05,188.1c-10.14-7.09-19.89-14-29.73-20.75a87.35,87.35,0,0,0-8.12-4.74c-3.73-2-6.38-1.68-9.51,1.26s-5.82,5.76-8.72,8.66a6.49,6.49,0,0,1-7,1.54c-3.84-1.18-5-4.72-2.71-7.92s4.86-6.6,7.27-9.91a12,12,0,0,1,9-5.27c5.72-.45,11.47-.84,17.21-.89,6.18-.05,12.37.27,18.56.56a3.43,3.43,0,0,1,2.42,1.39q8.16,13.86,16.07,27.87a3.6,3.6,0,0,1-.14,3.2A51.45,51.45,0,0,1,173.05,188.1Z"
      transform="translate(-29.71 -14)"
    />
    <path
      class="cls-9"
      d="M184.38,184.93c-7.82-13.6-15.53-27-23.44-40.77l15.24-7.76q11.64,20.11,23.29,40.23Z"
      transform="translate(-29.71 -14)"
    />
    <path
      class="cls-4"
      d="M112.85,197.06c.66,4.82-6,9-12.2,12.86-1.09.68-2.83,1.7-4.72,1.23a5,5,0,0,1-2.52-1.57c-1.93-2.19-1.65-5.17.83-7.39,3.44-3.07,7-6.07,10.47-9.06a4.85,4.85,0,0,1,4-1.34,3.9,3.9,0,0,1,1.5.68A7,7,0,0,1,112.85,197.06Z"
      transform="translate(-29.71 -14)"
    />
    <path
      class="cls-4"
      d="M119,211.47c-3.21,3.87-6.43,5.62-7.91,6.84-2.8,2.3-5.66,2.22-7.68-.09s-1.66-5.16,1-7.59,5.51-4.82,8.35-7.13a4.82,4.82,0,0,1,4-1.22,4.13,4.13,0,0,1,1.52.7c1.26.85,2.83,2.59,2.83,4.55C121.23,208.19,121.05,209.06,119,211.47Z"
      transform="translate(-29.71 -14)"
    />
    <path
      class="cls-4"
      d="M112.61,223.23c0-3.55,7-9.4,10.48-8.87s5.61,5,3.25,7.8a26.41,26.41,0,0,1-6.47,5.55A4.85,4.85,0,0,1,112.61,223.23Z"
      transform="translate(-29.71 -14)"
    />
    <path
      class="cls-4"
      d="M96.3,191.67a4.22,4.22,0,0,1,.6,1.53,4.8,4.8,0,0,1-1.51,4,25.7,25.7,0,0,1-4,3.37,4.71,4.71,0,0,1-5.64,0,4.66,4.66,0,0,1-2.05-5c.69-3.89,6.49-8.39,9.76-6.85A7.43,7.43,0,0,1,96.3,191.67Z"
      transform="translate(-29.71 -14)"
    />
    <path d="M121.23,199.15" transform="translate(-29.71 -14)" />
    <path class="cls-4" d="M118.09,193.39" transform="translate(-29.71 -14)" />
    <path class="cls-4" d="M135.89,250.47" transform="translate(-29.71 -14)" />
    <path class="cls-4" d="M121.23,224.81" transform="translate(-29.71 -14)" />
    <path d="M77.76,212.24" transform="translate(-29.71 -14)" />
    <path class="cls-10" d="M179.33,192.4" transform="translate(-29.71 -14)" />
    <path class="cls-10" d="M199.35,197.11" transform="translate(-29.71 -14)" />
    <path class="cls-10" d="M75.71,187.69" transform="translate(-29.71 -14)" />
    <path class="cls-11" d="M113.39,161.79" transform="translate(-29.71 -14)" />
    <path class="cls-11" d="M108.68,148.83" transform="translate(-29.71 -14)" />
    <path class="cls-11" d="M96.9,148.83" transform="translate(-29.71 -14)" />
    <path class="cls-10" d="M106.33,147.65" transform="translate(-29.71 -14)" />
    <path class="cls-10" d="M92.19,183" transform="translate(-29.71 -14)" />
    <path class="cls-11" d="M224.08,151.19" transform="translate(-29.71 -14)" />
    <path class="cls-10" d="M59.22,185.34" transform="translate(-29.71 -14)" />
    <path class="cls-10" d="M159.32,223" transform="translate(-29.71 -14)" />
    <path class="cls-10" d="M172.27,211.24" transform="translate(-29.71 -14)" />
    <rect
      class="cls-3"
      x="95.45"
      y="21.79"
      width="37.68"
      height="3.53"
      rx="0.98"
    />
    <rect
      class="cls-3"
      x="95.45"
      y="28.85"
      width="37.68"
      height="3.53"
      rx="0.98"
    />
    <rect
      class="cls-3"
      x="95.45"
      y="35.92"
      width="37.68"
      height="3.53"
      rx="0.98"
    />
    <path
      class="cls-3"
      d="M161.67,103.88v1.58c0,.54-.8,1-1.8,1H94c-1,0-1.81-.44-1.81-1v-1.58c0-.54.81-1,1.81-1h65.87C160.87,102.91,161.67,103.34,161.67,103.88Z"
      transform="translate(-29.71 -14)"
    />
    <path
      class="cls-3"
      d="M161.67,111v1.58c0,.54-.8,1-1.8,1H94c-1,0-1.81-.44-1.81-1V111c0-.54.81-1,1.81-1h65.87C160.87,110,161.67,110.41,161.67,111Z"
      transform="translate(-29.71 -14)"
    />
    <path
      class="cls-3"
      d="M161.67,118v1.57c0,.54-.8,1-1.8,1H94c-1,0-1.81-.44-1.81-1V118c0-.55.81-1,1.81-1h65.87C160.87,117,161.67,117.47,161.67,118Z"
      transform="translate(-29.71 -14)"
    />
    <rect
      class="cls-3"
      x="62.48"
      y="58.29"
      width="69.48"
      height="3.53"
      rx="0.98"
    />
    <rect
      class="cls-3"
      x="62.48"
      y="66.53"
      width="69.48"
      height="3.53"
      rx="0.98"
    />
    <rect
      class="cls-3"
      x="62.48"
      y="75.95"
      width="69.48"
      height="3.53"
      rx="0.98"
    />
    <path class="cls-11" d="M116.92,142.94" transform="translate(-29.71 -14)" />
    <path class="cls-6" d="M171.09,128.81" transform="translate(-29.71 -14)" />
    <path class="cls-12" d="M179.33,130" transform="translate(-29.71 -14)" />
    <path class="cls-12" d="M171.16,24.12" transform="translate(-29.71 -14)" />
    <path
      d="M92.36,54a10.38,10.38,0,0,1,.86-5.87,12.36,12.36,0,0,1,23.49,2.14,21.93,21.93,0,0,1,.21,3.73Zm1.1-1.26h22.36a11.18,11.18,0,0,0-22.36,0Z"
      transform="translate(-29.71 -14)"
    />
    <path
      class="cls-3"
      d="M105.51,24.13a9.14,9.14,0,0,1,3.86,1.61A7.77,7.77,0,0,1,112,34.42a7.72,7.72,0,1,1-8.47-10.18,1.21,1.21,0,0,0,.3-.11Zm-.8,1.2a6.54,6.54,0,1,0,6.49,6.51A6.59,6.59,0,0,0,104.71,25.33Z"
      transform="translate(-29.71 -14)"
    />
    <path
      class="cls-3"
      d="M93.46,52.74a11.18,11.18,0,0,1,22.36,0Z"
      transform="translate(-29.71 -14)"
    />
    <path
      class="cls-4"
      d="M105.1,26.53a4.94,4.94,0,1,1-5,4.94A4.94,4.94,0,0,1,105.1,26.53Z"
      transform="translate(-29.71 -14)"
    />
    <path d="M120,211" transform="translate(-29.71 -14)" />
    <path d="M130,211" transform="translate(-29.71 -14)" />
    <path class="cls-4" d="M129,208" transform="translate(-29.71 -14)" />
    <path class="cls-4" d="M131,217" transform="translate(-29.71 -14)" />
    <path d="M84,186" transform="translate(-29.71 -14)" />
  </svg>
);

export const talentsAec = (props) => (
  <svg
    {...props}
    id="prefix__Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x={0}
    y={0}
    viewBox="0 0 1366 980"
    xmlSpace="preserve"
  >
    <style>
      {
        ".prefix__st1,.prefix__st2,.prefix__st3,.prefix__st4{stroke-width:11.5385;stroke-linejoin:round;stroke-miterlimit:10}.prefix__st1{fill:none;stroke:#0c6bc2;stroke-linecap:round;stroke-dasharray:46.1538}.prefix__st2,.prefix__st3,.prefix__st4{stroke:#0b6bc0}.prefix__st2{fill:#c8f2ff;stroke-linecap:round}.prefix__st3,.prefix__st4{fill:#64bdfa}.prefix__st4{fill:#fff;stroke-linecap:round}"
      }
    </style>
    <circle cx={686.38} cy={504.32} r={346.15} fill="#92e0ff" />
    <path
      className="prefix__st1"
      d="M275.79 265.77c-31.76 54.54-52.96 115.98-60.8 181.52-2.24 18.7-3.39 37.73-3.39 57.03M1052.75 202.31C965.67 96.79 833.88 29.53 686.38 29.53c-2.48 0-4.95.02-7.41.06M998.16 862.41c80.74-70.36 137.47-167.58 156.24-277.74M237.67 654.4c32.67 103.91 100.25 192.92 189.53 252.59"
    />
    <g>
      <path
        className="prefix__st2"
        d="M369.31 249.36c0-94.05 78.89-169.99 172.94-169.99S715.3 157.65 715.3 251.7c0 94.05-79 172.62-173.05 172.62s-172.94-80.91-172.94-174.96z"
      />
      <path
        className="prefix__st3"
        d="M222.92 580.56l19.27 19.27c5.3 5.3 13.89 5.3 19.19 0l138.58-138.58c5.3-5.3 5.3-13.89 0-19.19l-19.27-19.27c-5.3-5.3-13.89-5.3-19.19 0L222.92 561.37c-5.3 5.3-5.3 13.89 0 19.19z"
      />
      <path
        className="prefix__st4"
        d="M275.79 585.41l-38.45-38.46M390.33 432.41l28.12-28.12"
      />
      <circle
        transform="rotate(-45.001 542.254 251.765)"
        className="prefix__st4"
        cx={542.25}
        cy={251.76}
        r={196.47}
      />
      <circle
        transform="rotate(-45.001 542.254 251.765)"
        className="prefix__st2"
        cx={542.25}
        cy={251.76}
        r={165.96}
      />
      <g>
        <ellipse
          className="prefix__st4"
          cx={543.75}
          cy={176.37}
          rx={44.93}
          ry={46.52}
        />
        <path
          className="prefix__st3"
          d="M457.67 338.76s4.18-90.32 57.53-91.98c21.84-.68 40.74-.42 56.59-.11 55.61 1.08 55.04 92.63 55.04 92.66 0 8.18-37.87 14.82-84.58 14.82s-84.58-6.63-84.58-14.82c0-.19.04-.38.08-.57h-.08z"
        />
      </g>
    </g>
    <g>
      <path
        className="prefix__st3"
        d="M908.08 631.56v237.98c0 9.31-7.54 16.85-16.85 16.85H732.76c-9.31 0-16.85 7.54-16.85 16.85 0 9.31 7.54 16.85 16.85 16.85h204.51V631.56c0-6.46-5.24-11.7-11.7-11.7h-5.79c-6.46 0-11.7 5.24-11.7 11.7z"
      />
      <circle
        transform="rotate(-45.001 616.272 584.655)"
        className="prefix__st4"
        cx={616.28}
        cy={584.65}
        r={86.66}
      />
      <path
        className="prefix__st4"
        d="M620.71 868.42l49.66 67.05c8.05 12.34 153.94 3.35 153.94 3.35 23.46-3.33 41.34-24.32 38.69-47.86-2.73-24.33-24.01-38.22-49.06-38.03l-86.67 1.72c-11.7.23-22.26-6.98-26.31-17.96 0 0-34.02-78.58-52.81-102.58l-.18-.23c-13.47-17.29-34.51-27.74-55.4-29.12-71.19-4.7-103.97 37.62-108.07 93.2l-11.56 153.01H699"
      />
      <path
        className="prefix__st4"
        d="M1015.12 935.81c0-8.68-6.5-15.72-14.52-15.72l-384.49-1.55-2.35 32.92h386.84c8.02.01 14.52-7.03 14.52-15.65zM1093.45 282.62H827.9c-31.52 0-57.08 25.55-57.08 57.08v154.69c0 23.98 19.44 43.42 43.42 43.42h19.81l25.34 74.11 60.25-65.2a33.952 33.952 0 0121.78-7.91l152.03-.1c31.51-.01 57.06-20.01 57.06-51.53V339.7c.02-31.53-25.54-57.08-57.06-57.08z"
      />
      <g>
        <circle className="prefix__st2" cx={871.28} cy={412.64} r={23.31} />
        <circle className="prefix__st2" cx={964.76} cy={412.64} r={23.31} />
        <circle className="prefix__st2" cx={1056.1} cy={412.64} r={23.31} />
      </g>
    </g>
  </svg>
);

export const configurations = (props) => (
  <svg
    {...props}
    id="prefix__Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x={0}
    y={0}
    viewBox="0 0 1024 990"
    xmlSpace="preserve"
  >
    <style>
      {
        ".prefix__st1{fill:none;stroke-linecap:round;stroke-dasharray:46.1538}.prefix__st1,.prefix__st2,.prefix__st3,.prefix__st4,.prefix__st6{stroke:#0c6bc2;stroke-width:11.5385;stroke-linejoin:round;stroke-miterlimit:10}.prefix__st2{fill:#fff;stroke-linecap:round}.prefix__st3,.prefix__st4,.prefix__st6{fill:#65bffc}.prefix__st4,.prefix__st6{fill:#caf4ff;stroke-linecap:round}.prefix__st6{fill:none}"
      }
    </style>
    <circle cx={528.88} cy={500.73} r={346.15} fill="#92e0ff" />
    <path
      className="prefix__st1"
      d="M171.91 793.33c-46.6-56.79-79.92-124.9-95.2-199.58M974.51 621.33c-12.61 46.71-32.37 90.49-58.03 130.09M358.88 71.5c52.61-20.85 109.97-32.32 170-32.32 84.78 0 164.22 22.86 232.49 62.74"
    />
    <path
      className="prefix__st2"
      d="M364.13 499.14l18.05-4.33a4.815 4.815 0 003.56-5.81l-2.32-9.67c-.26-1.1.24-2.22 1.21-2.81 2.56-1.55 4.97-3.3 7.2-5.23.86-.74 2.08-.87 3.04-.28l8.48 5.2c2.27 1.39 5.24.68 6.63-1.59l9.7-15.83c1.39-2.27.68-5.24-1.59-6.63l-8.48-5.2a2.574 2.574 0 01-1.13-2.84c.71-2.86 1.18-5.8 1.4-8.79a2.59 2.59 0 011.96-2.35l9.67-2.32a4.815 4.815 0 003.56-5.81l-4.33-18.05a4.815 4.815 0 00-5.81-3.56l-9.67 2.32c-1.1.26-2.22-.24-2.81-1.21-1.55-2.56-3.3-4.97-5.23-7.2-.74-.86-.87-2.08-.28-3.04l5.2-8.48c1.39-2.27.68-5.24-1.59-6.63l-15.83-9.7a4.822 4.822 0 00-6.63 1.59l-5.2 8.48c-.59.96-1.74 1.41-2.84 1.13-2.86-.71-5.8-1.18-8.79-1.4a2.59 2.59 0 01-2.35-1.96l-2.32-9.67a4.815 4.815 0 00-5.81-3.56l-18.05 4.33a4.815 4.815 0 00-3.56 5.81l2.32 9.67c.26 1.1-.24 2.22-1.21 2.81-2.56 1.55-4.97 3.3-7.2 5.23-.86.74-2.08.87-3.04.28l-8.48-5.2a4.822 4.822 0 00-6.63 1.59l-9.71 15.83a4.822 4.822 0 001.59 6.63l8.48 5.2c.96.59 1.41 1.74 1.13 2.84-.71 2.86-1.18 5.8-1.4 8.79a2.59 2.59 0 01-1.96 2.35l-9.67 2.32a4.815 4.815 0 00-3.56 5.81l4.33 18.05a4.815 4.815 0 005.81 3.56l9.67-2.32c1.1-.26 2.22.24 2.81 1.2 1.55 2.56 3.3 4.97 5.23 7.2.74.86.87 2.08.28 3.04l-5.2 8.48a4.822 4.822 0 001.59 6.63l15.83 9.7c2.27 1.39 5.24.68 6.63-1.59l5.2-8.48c.59-.96 1.74-1.41 2.84-1.13 2.86.71 5.8 1.18 8.79 1.4 1.13.08 2.08.86 2.35 1.96l2.32 9.67c.64 2.59 3.24 4.19 5.82 3.57zm-25.28-63.15c-2.47-10.28 3.87-20.62 14.15-23.08 10.28-2.47 20.62 3.87 23.08 14.15 2.47 10.28-3.87 20.62-14.15 23.08-10.28 2.47-20.61-3.87-23.08-14.15z"
    />
    <path
      className="prefix__st3"
      d="M150.47 540.11l24.68-5.92c3.54-.85 5.72-4.4 4.87-7.94l-3.17-13.22c-.36-1.5.32-3.04 1.65-3.84a71.49 71.49 0 009.84-7.15c1.17-1.01 2.84-1.19 4.16-.38l11.59 7.11c3.1 1.9 7.16.93 9.06-2.17l13.27-21.63c1.9-3.1.93-7.16-2.17-9.06l-11.59-7.11c-1.32-.81-1.92-2.38-1.55-3.88.97-3.92 1.61-7.93 1.91-12.02.11-1.54 1.17-2.85 2.67-3.21l13.22-3.17c3.54-.85 5.72-4.4 4.87-7.94l-5.92-24.68a6.582 6.582 0 00-7.94-4.87l-13.22 3.17c-1.5.36-3.04-.32-3.84-1.65a71.49 71.49 0 00-7.15-9.84c-1.01-1.17-1.19-2.84-.38-4.16l7.11-11.59c1.9-3.1.93-7.16-2.17-9.06l-21.63-13.27a6.59 6.59 0 00-9.06 2.17l-7.11 11.59c-.81 1.32-2.38 1.92-3.88 1.55-3.92-.97-7.93-1.61-12.02-1.91-1.54-.11-2.85-1.17-3.21-2.67l-3.17-13.22a6.582 6.582 0 00-7.94-4.87l-24.68 5.92c-3.54.85-5.72 4.4-4.87 7.94l3.17 13.22c.36 1.5-.32 3.04-1.65 3.84a71.49 71.49 0 00-9.84 7.15c-1.17 1.01-2.84 1.19-4.16.38l-11.59-7.11a6.59 6.59 0 00-9.06 2.17L56.3 410.41a6.59 6.59 0 002.17 9.06l11.59 7.11c1.32.81 1.92 2.38 1.55 3.88-.97 3.92-1.61 7.93-1.91 12.02-.11 1.54-1.17 2.85-2.67 3.21l-13.22 3.17c-3.54.85-5.72 4.4-4.87 7.94l5.92 24.68c.85 3.54 4.4 5.72 7.94 4.87l13.22-3.17c1.5-.36 3.04.32 3.84 1.65a71.49 71.49 0 007.15 9.84c1.01 1.17 1.19 2.84.38 4.16l-7.11 11.59a6.59 6.59 0 002.17 9.06l21.63 13.27c3.1 1.9 7.16.93 9.06-2.17l7.11-11.59c.81-1.32 2.38-1.92 3.88-1.55 3.92.97 7.93 1.61 12.02 1.91 1.54.11 2.85 1.17 3.21 2.67l3.17 13.22c.85 3.53 4.4 5.71 7.94 4.87zm-34.56-86.32c-3.37-14.05 5.29-28.18 19.35-31.55 14.05-3.37 28.18 5.29 31.55 19.35 3.37 14.05-5.29 28.18-19.35 31.55-14.05 3.37-28.18-5.29-31.55-19.35z"
    />
    <path
      className="prefix__st4"
      d="M319.61 319.3l26.2-20.81c3.76-2.98 4.38-8.45 1.4-12.2l-11.15-14.04c-1.27-1.6-1.3-3.81-.17-5.5 3.01-4.48 5.61-9.17 7.78-14.03.83-1.86 2.74-3 4.76-2.77l17.81 2.04c4.76.55 9.07-2.87 9.62-7.64l3.81-33.24c.55-4.76-2.87-9.07-7.64-9.62l-17.81-2.04c-2.03-.23-3.62-1.77-4.01-3.77a94.29 94.29 0 00-4.41-15.43c-.72-1.9-.19-4.05 1.41-5.32l14.04-11.15c3.76-2.98 4.38-8.45 1.4-12.2l-20.81-26.2c-2.98-3.76-8.45-4.38-12.2-1.4l-14.04 11.15c-1.6 1.27-3.81 1.3-5.5.17a93.533 93.533 0 00-14.03-7.78c-1.86-.83-3-2.74-2.77-4.76l2.04-17.81c.55-4.76-2.87-9.07-7.64-9.62l-33.24-3.81c-4.76-.55-9.07 2.87-9.62 7.64l-2.04 17.81c-.23 2.03-1.77 3.62-3.77 4.01a94.29 94.29 0 00-15.43 4.41c-1.9.72-4.05.19-5.32-1.41l-11.15-14.04c-2.98-3.76-8.45-4.38-12.2-1.4l-26.2 20.81c-3.76 2.98-4.38 8.45-1.4 12.2l11.15 14.04c1.27 1.6 1.3 3.81.17 5.5a93.533 93.533 0 00-7.78 14.03c-.83 1.86-2.74 3-4.76 2.77l-17.81-2.04c-4.76-.55-9.07 2.87-9.62 7.64l-3.81 33.24c-.55 4.76 2.87 9.07 7.64 9.62l17.81 2.04c2.03.23 3.62 1.77 4.01 3.77a94.29 94.29 0 004.41 15.43c.72 1.9.19 4.05-1.41 5.32l-14.04 11.15c-3.76 2.98-4.38 8.45-1.4 12.2l20.81 26.2c2.98 3.76 8.45 4.38 12.2 1.4l14.04-11.15c1.6-1.27 3.81-1.3 5.5-.17 4.48 3.01 9.17 5.61 14.03 7.78 1.86.83 3 2.74 2.77 4.76l-2.04 17.81c-.55 4.76 2.87 9.07 7.64 9.62l33.24 3.81c4.76.55 9.07-2.87 9.62-7.64l2.04-17.81c.23-2.03 1.77-3.62 3.77-4.01a94.29 94.29 0 0015.43-4.41c1.9-.72 4.05-.19 5.32 1.41l11.15 14.04c2.99 3.75 8.45 4.38 12.2 1.4z"
    />
    <circle
      transform="rotate(-31.28 257.281 213.925)"
      className="prefix__st2"
      cx={257.28}
      cy={213.92}
      r={56.76}
    />
    <g>
      <path
        className="prefix__st2"
        d="M772.39 880.84h-467.4V621.59c0-15.52 12.6-28.17 28.12-28.17h411.11c15.58 0 28.17 12.66 28.17 28.17v259.25zM812.29 954H265.04c-5.61 0-8.47-6.81-4.47-10.82l44.41-60.05h467.4l44.36 60.05c4.02 4.01 1.21 10.82-4.45 10.82z"
      />
      <path
        className="prefix__st2"
        d="M772.39 880.84l44.36 62.34c4.01 4.01 1.2 10.82-4.47 10.82H265.04c-5.61 0-8.47-6.81-4.47-10.82l44.41-62.34"
      />
      <path
        className="prefix__st3"
        d="M600.31 954l-7.22-22.4a2.17 2.17 0 00-1.85-1.06H486.76c-.75 0-1.45.4-1.85 1.06l-7.22 22.4h122.62z"
      />
      <path className="prefix__st2" d="M312.43 905.3h453.13" />
      <path
        className="prefix__st4"
        d="M772.39 621.59v259.25h-467.4V621.59c0-15.52 12.6-28.17 28.12-28.17h411.11c15.58-.01 28.17 12.65 28.17 28.17z"
      />
      <path
        className="prefix__st2"
        d="M741.88 858.81H335.47c-4.15 0-7.52-3.37-7.52-7.52V627.36c0-4.15 3.37-7.52 7.52-7.52h406.42c4.15 0 7.52 3.37 7.52 7.52V851.3a7.53 7.53 0 01-7.53 7.51z"
      />
      <g>
        <path
          className="prefix__st2"
          d="M580.87 652.76h124.72M580.87 695.92h124.72M580.87 739.09h124.72M368.83 780.6h339.68M368.83 823.77h339.68"
        />
        <path className="prefix__st3" d="M368.83 652.45h174.02v95.02H368.83z" />
      </g>
    </g>
    <g>
      <path
        d="M837.11 157.56l12.76 15.63a5.926 5.926 0 007.8 1.24l16.97-10.92c3.15-2.03 7.37-.66 8.73 2.84l7.31 18.81a5.919 5.919 0 007.03 3.58l19.51-5.15c3.63-.96 7.22 1.65 7.43 5.4l1.14 20.15a5.921 5.921 0 005.58 5.58l20.15 1.14c3.74.21 6.35 3.8 5.4 7.43l-5.15 19.51c-.77 2.92.77 5.94 3.58 7.03l18.81 7.31c3.49 1.36 4.87 5.58 2.84 8.73l-10.92 16.97a5.937 5.937 0 001.23 7.8l15.63 12.76c2.9 2.37 2.9 6.81 0 9.18l-15.63 12.76a5.914 5.914 0 00-1.23 7.8L977 350.09c2.03 3.15.66 7.37-2.84 8.73l-18.81 7.31a5.919 5.919 0 00-3.58 7.03l5.15 19.51c.96 3.63-1.65 7.22-5.4 7.43l-20.15 1.14a5.921 5.921 0 00-5.58 5.58l-1.14 20.15c-.21 3.74-3.8 6.35-7.43 5.4l-19.51-5.15c-2.91-.77-5.94.77-7.03 3.58l-7.31 18.81c-1.36 3.49-5.58 4.87-8.73 2.84l-16.97-10.92a5.937 5.937 0 00-7.8 1.23l-12.76 15.63c-2.37 2.9-6.81 2.9-9.18 0l-12.76-15.63a5.914 5.914 0 00-7.8-1.23l-16.97 10.92c-3.15 2.03-7.37.66-8.73-2.84l-7.31-18.81a5.919 5.919 0 00-7.03-3.58l-19.51 5.15c-3.63.96-7.22-1.65-7.43-5.4l-1.14-20.15a5.921 5.921 0 00-5.58-5.58l-20.15-1.14c-3.74-.21-6.35-3.8-5.4-7.43l5.15-19.51c.77-2.92-.77-5.94-3.58-7.03l-18.81-7.31c-3.49-1.36-4.87-5.58-2.84-8.73l10.92-16.97a5.937 5.937 0 00-1.23-7.8l-15.63-12.76c-2.9-2.37-2.9-6.81 0-9.18l15.63-12.76a5.914 5.914 0 001.23-7.8l-10.92-16.97c-2.03-3.15-.66-7.37 2.84-8.73l18.81-7.31a5.919 5.919 0 003.58-7.03l-5.15-19.51c-.96-3.63 1.65-7.22 5.4-7.43l20.15-1.14a5.921 5.921 0 005.58-5.58l1.14-20.15c.21-3.74 3.8-6.35 7.43-5.4l19.51 5.15c2.92.77 5.94-.77 7.03-3.58l7.31-18.81c1.36-3.49 5.58-4.87 8.73-2.84l16.97 10.92a5.928 5.928 0 007.8-1.24l12.76-15.63c2.37-2.89 6.81-2.89 9.18.02z"
        fill="#caf4ff"
      />
      <path
        className="prefix__st6"
        d="M837.11 157.56l12.76 15.63a5.926 5.926 0 007.8 1.24l16.97-10.92c3.15-2.03 7.37-.66 8.73 2.84l7.31 18.81a5.919 5.919 0 007.03 3.58l19.51-5.15c3.63-.96 7.22 1.65 7.43 5.4l1.14 20.15a5.921 5.921 0 005.58 5.58l20.15 1.14c3.74.21 6.35 3.8 5.4 7.43l-5.15 19.51c-.77 2.92.77 5.94 3.58 7.03l18.81 7.31c3.49 1.36 4.87 5.58 2.84 8.73l-10.92 16.97a5.937 5.937 0 001.23 7.8l15.63 12.76c2.9 2.37 2.9 6.81 0 9.18l-15.63 12.76a5.914 5.914 0 00-1.23 7.8L977 350.09c2.03 3.15.66 7.37-2.84 8.73l-18.81 7.31a5.919 5.919 0 00-3.58 7.03l5.15 19.51c.96 3.63-1.65 7.22-5.4 7.43l-20.15 1.14a5.921 5.921 0 00-5.58 5.58l-1.14 20.15c-.21 3.74-3.8 6.35-7.43 5.4l-19.51-5.15c-2.91-.77-5.94.77-7.03 3.58l-7.31 18.81c-1.36 3.49-5.58 4.87-8.73 2.84l-16.97-10.92a5.937 5.937 0 00-7.8 1.23l-12.76 15.63c-2.37 2.9-6.81 2.9-9.18 0l-12.76-15.63a5.914 5.914 0 00-7.8-1.23l-16.97 10.92c-3.15 2.03-7.37.66-8.73-2.84l-7.31-18.81a5.919 5.919 0 00-7.03-3.58l-19.51 5.15c-3.63.96-7.22-1.65-7.43-5.4l-1.14-20.15a5.921 5.921 0 00-5.58-5.58l-20.15-1.14c-3.74-.21-6.35-3.8-5.4-7.43l5.15-19.51c.77-2.92-.77-5.94-3.58-7.03l-18.81-7.31c-3.49-1.36-4.87-5.58-2.84-8.73l10.92-16.97a5.937 5.937 0 00-1.23-7.8l-15.63-12.76c-2.9-2.37-2.9-6.81 0-9.18l15.63-12.76a5.914 5.914 0 001.23-7.8l-10.92-16.97c-2.03-3.15-.66-7.37 2.84-8.73l18.81-7.31a5.919 5.919 0 003.58-7.03l-5.15-19.51c-.96-3.63 1.65-7.22 5.4-7.43l20.15-1.14a5.921 5.921 0 005.58-5.58l1.14-20.15c.21-3.74 3.8-6.35 7.43-5.4l19.51 5.15c2.92.77 5.94-.77 7.03-3.58l7.31-18.81c1.36-3.49 5.58-4.87 8.73-2.84l16.97 10.92a5.928 5.928 0 007.8-1.24l12.76-15.63c2.37-2.89 6.81-2.89 9.18.02z"
      />
      <g>
        <path
          className="prefix__st6"
          d="M777.55 319.73l35 27.86c3.01 2.4 7.41 1.9 9.82-1.1l75.71-94.55"
        />
      </g>
    </g>
  </svg>
);

export const deleteItem = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="8"
    viewBox="0 0 10 8"
  >
    <g fill="none" fillRule="evenodd" stroke="#000000" strokeLinecap="round">
      <path d="M1.286.308L8.978 8M8.714.308L1.022 8" />
    </g>
  </svg>
);

export const statusOkFill = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="21"
    viewBox="0 0 20 21"
    style={{ display: "flex", alignSelf: "center" }}
  >
    <g fill="none" fillRule="evenodd" transform="translate(0 .5)">
      <circle cx="10" cy="10" r="10" fill="#BBB" />
      <path
        fill="#FFF"
        d="M8.606 13.958a.67.67 0 0 1-.469-.19l-2.942-2.87a.639.639 0 0 1 0-.919.675.675 0 0 1 .938 0l2.473 2.413 5.886-5.744a.675.675 0 0 1 .939 0 .639.639 0 0 1 0 .919l-6.355 6.202a.67.67 0 0 1-.47.19"
      />
    </g>
  </svg>
);

export const view = () => (
  <svg width="24" height="24" viewBox="0 0 16 16">
    <path d="M14 8l-.124.232c-.02.039-.518.962-1.484 1.887C11.106 11.35 9.592 12 8.012 12c-1.579 0-3.097-.65-4.39-1.88a8.385 8.385 0 0 1-1.496-1.886L2 8l.126-.234c.021-.039.524-.962 1.496-1.886C4.915 4.65 6.433 4 8.012 4c1.58 0 3.094.65 4.38 1.88a8.318 8.318 0 0 1 1.484 1.888L14 8zm-1.672.025L12.346 8a7.351 7.351 0 0 0-.936-1.093C10.38 5.92 9.213 5.42 8.012 5.42s-2.374.502-3.411 1.489A7.43 7.43 0 0 0 3.659 8l.015.022c.26.364.57.73.927 1.07 1.037.986 2.21 1.488 3.411 1.488s2.368-.501 3.398-1.486a7.35 7.35 0 0 0 .918-1.07zM8 6c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zm0 1.42a.582.582 0 0 0-.58.58c0 .319.261.58.58.58.319 0 .58-.261.58-.58A.582.582 0 0 0 8 7.42z" />
  </svg>
);

export const statusFinishedFill = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    style={{ display: "flex", alignSelf: "center" }}
  >
    <g fill="none" fillRule="evenodd">
      <circle cx="10" cy="10" r="10" fill="#8BC63F" />
      <g fill="#FFF" transform="translate(4.167 8.333)">
        <ellipse cx="1.359" cy="1.346" rx="1.359" ry="1.346" />
        <ellipse cx="5.846" cy="1.346" rx="1.359" ry="1.346" />
        <ellipse cx="10.333" cy="1.346" rx="1.359" ry="1.346" />
      </g>
    </g>
  </svg>
);

export const edit = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
  >
    <g fillRule="evenodd" opacity=".7">
      <path d="M12 0C5.372 0 0 5.372 0 12s5.372 12 12 12 12-5.372 12-12C23.992 5.376 18.624.008 12 0zm0 22.5C6.201 22.5 1.5 17.799 1.5 12S6.201 1.5 12 1.5 22.5 6.201 22.5 12c-.006 5.796-4.704 10.494-10.5 10.5z" />
      <path
        fillRule="nonzero"
        d="M13.462 8.003l2.441 2.453-6.18 6.209-2.439-2.453 6.178-6.21zm4.293-.592l-1.088-1.094a1.077 1.077 0 0 0-1.526 0l-1.043 1.048 2.44 2.453 1.217-1.222a.84.84 0 0 0 0-1.185zM6.007 17.66c-.045.2.136.38.336.332l2.72-.663-2.44-2.453-.616 2.784z"
      />
    </g>
  </svg>
);

export const start = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="24"
    viewBox="0 0 24 24"
  >
    <g fill="#000" fillRule="evenodd">
      <path
        d="M12 0C5.372 0 0 5.372 0 12s5.372 12 12 12 12-5.372 12-12C23.992 5.376 18.624.008 12 0zm0 22.5C6.201 22.5 1.5 17.799 1.5 12S6.201 1.5 12 1.5 22.5 6.201 22.5 12c-.006 5.796-4.704 10.494-10.5 10.5z"
        opacity=".7"
      />
      <path d="M9.96 16.724L6 12.763l1.68-1.681 2.28 2.28L16.32 7 18 8.68z" />
    </g>
  </svg>
);

export const choice = () => (
  <svg viewBox="0 0 120 120">
    <defs>
      <path id="a" d="M0 0h120v120H0z" />
    </defs>
    <g fillRule="evenodd">
      <path
        d="M119.793 11.882a1.914 1.914 0 0 0-2-1.027L107.57 12.43l1.575-10.224A1.916 1.916 0 0 0 105.9.56L94.03 12.43c-.288.287-.476.659-.539 1.061L91.613 25.68l-6.793 6.793c-9.359-8.688-21.473-13.453-34.328-13.453-13.498 0-26.18 5.249-35.712 14.78C5.248 43.33 0 56.011 0 69.508c0 13.498 5.248 26.18 14.78 35.712C24.312 114.75 36.994 120 50.49 120c13.498 0 26.18-5.248 35.712-14.78 9.53-9.532 14.779-22.214 14.779-35.71 0-10.737-3.317-20.986-9.596-29.638a1.915 1.915 0 0 0-3.099 2.25c5.8 7.994 8.865 17.464 8.865 27.388 0 25.728-20.932 46.66-46.66 46.66-25.73 0-46.661-20.932-46.661-46.66 0-25.73 20.932-46.661 46.66-46.661 11.834 0 22.987 4.367 31.62 12.333l-8.754 8.755C67.06 38.299 58.999 35.21 50.49 35.21c-18.912 0-34.298 15.386-34.298 34.299 0 18.912 15.386 34.298 34.298 34.298 18.913 0 34.3-15.386 34.3-34.298 0-6.312-1.726-12.481-4.991-17.838a1.915 1.915 0 1 0-3.272 1.993A30.421 30.421 0 0 1 80.96 69.51c0 16.8-13.668 30.47-30.469 30.47-16.8 0-30.468-13.67-30.468-30.47 0-16.8 13.667-30.47 30.468-30.47 7.488 0 14.586 2.691 20.154 7.608l-8.774 8.774a17.97 17.97 0 0 0-11.38-4.02c-9.984 0-18.106 8.124-18.106 18.108s8.122 18.106 18.106 18.106c9.985 0 18.107-8.122 18.107-18.106 0-1.778-.258-3.537-.765-5.225a1.915 1.915 0 0 0-3.668 1.102c.4 1.33.604 2.718.604 4.123 0 7.872-6.406 14.276-14.278 14.276-7.872 0-14.276-6.404-14.276-14.276s6.404-14.278 14.276-14.278c3.17 0 6.179 1.028 8.652 2.918L49.137 68.156a1.915 1.915 0 0 0 2.707 2.709l42.477-42.477 12.187-1.879a1.92 1.92 0 0 0 1.063-.538l11.867-11.869c.587-.587.73-1.482.355-2.22zm-22.612 2.812l7.288-7.286-.987 6.402-7.287 7.287.986-6.403zm8.125 8.125l-6.403.987 7.288-7.288 6.401-.987-7.286 7.288z"
        mask="url(#b)"
      />
    </g>
  </svg>
);

export const rails = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g fillRule="evenodd">
      <path d="M12 0C5.372 0 0 5.372 0 12s5.372 12 12 12 12-5.372 12-12C23.992 5.376 18.624.008 12 0zm0 22.5C6.201 22.5 1.5 17.799 1.5 12S6.201 1.5 12 1.5 22.5 6.201 22.5 12c-.006 5.796-4.704 10.494-10.5 10.5z" />
      <path
        fillRule="nonzero"
        d="M13.107 15.492c.746.259 1.404.423 2.35.717-.364 4.646-4.705 2.801-2.35-.717zm3.876-4.268C16.934 9.83 16.691 8 14.757 8.286c-.906.24-1.576 1.247-1.891 2.986-.173.955-.073 2.297.132 3.101.186.567.123.532.323.64a92.71 92.71 0 0 1 2.324.572c.794-.568 1.446-3.58 1.338-4.36zm-5.968-.107c.204-.804.304-2.146.131-3.101-.314-1.739-.984-2.747-1.891-2.986-1.934-.287-2.177 1.543-2.226 2.938-.108.78.544 3.793 1.338 4.36.782-.199 1.55-.394 2.325-.571.2-.108.136-.073.323-.64zm-2.46 1.836c.364 4.646 4.705 2.801 2.35-.717-.745.259-1.404.423-2.35.717z"
      />
    </g>
  </svg>
);

export const trainerAec = () => (
  <svg viewBox="0 0 120 120">
    <g fillRule="evenodd">
      <path d="M114.967 73.927V6.879c0-1-.82-1.812-1.83-1.812H7.08A1.82 1.82 0 0 0 5.252 6.88v67.048c0 1 .818 1.812 1.828 1.812h25.667L5.6 112.728l2.96 2.13L37.267 75.74H58.28v38.054h3.657V75.739H82.95l28.709 39.12 2.958-2.131-27.145-36.989h25.665c1.01 0 1.83-.812 1.83-1.812zM8.909 72.115h102.4V8.692H8.91v63.423z" />
      <path d="M40.909 34.06c-3.535 0-6.4 2.84-6.4 6.343s2.865 6.342 6.4 6.342 6.4-2.839 6.4-6.342c0-3.503-2.865-6.343-6.4-6.343zm0 9.06c-1.515 0-2.743-1.216-2.743-2.717 0-1.5 1.228-2.718 2.743-2.718s2.743 1.217 2.743 2.718c0 1.5-1.228 2.718-2.743 2.718zM22.623 52.181c-3.535 0-6.4 2.84-6.4 6.343s2.865 6.342 6.4 6.342c3.536 0 6.4-2.839 6.4-6.342 0-3.503-2.864-6.343-6.4-6.343zm0 9.06c-1.515 0-2.742-1.216-2.742-2.717 0-1.5 1.227-2.718 2.742-2.718s2.743 1.217 2.743 2.718c0 1.5-1.228 2.718-2.743 2.718zM61.023 46.745c-3.534 0-6.4 2.84-6.4 6.343s2.866 6.342 6.4 6.342c3.535 0 6.4-2.84 6.4-6.342 0-3.503-2.865-6.343-6.4-6.343zm0 9.06c-1.514 0-2.743-1.216-2.743-2.717 0-1.502 1.229-2.718 2.743-2.718 1.515 0 2.743 1.216 2.743 2.718 0 1.5-1.228 2.718-2.743 2.718zM79.31 25c-3.535 0-6.401 2.84-6.401 6.343s2.866 6.342 6.4 6.342c3.535 0 6.4-2.84 6.4-6.342 0-3.503-2.865-6.343-6.4-6.343zm0 9.06c-1.515 0-2.744-1.217-2.744-2.717 0-1.501 1.229-2.719 2.743-2.719 1.515 0 2.742 1.218 2.742 2.719 0 1.5-1.227 2.717-2.742 2.717zM97.595 15.94c-3.535 0-6.4 2.84-6.4 6.342 0 3.503 2.865 6.342 6.4 6.342 3.534 0 6.4-2.839 6.4-6.342 0-3.503-2.866-6.343-6.4-6.343zm0 9.06c-1.515 0-2.744-1.217-2.744-2.718 0-1.5 1.23-2.718 2.744-2.718 1.514 0 2.742 1.217 2.742 2.718S99.11 25 97.595 25zM27.73 50.9l5.487-5.437 2.586 2.563-5.487 5.437zM66.073 44.25l5.994-7.13 2.809 2.32-5.994 7.13zM86.373 25.815l2.765-1.37 1.637 3.241-2.766 1.37zM48.282 46.93l2.014-3.025 4.47 2.922-2.015 3.025z" />
    </g>
  </svg>
);

export const onboard = () => (
  <svg viewBox="0 0 120 120">
    <g fillRule="evenodd">
      <path d="M21 81H5c-1.104 0-2 .871-2 1.946v33.107C3 117.13 3.895 118 4.998 118H21c1.105.001 2.001-.871 2.001-1.946V82.947C23 81.872 22.105 81 21 81zM7 114.106h12v-29.21H7v29.21zM92.002 66H76c-1.105-.001-2.001.878-2.001 1.961v49.077c0 1.084.895 1.962 2 1.962h16c1.104.001 2-.878 2-1.961V67.962C94 66.878 93.105 66 92.002 66zM78 115.075h12v-45.15H78v45.15zM68.002 76H52c-1.105-.001-2 .874-2.001 1.953v39.093c0 1.08.895 1.954 2 1.954h16c1.105.001 2-.874 2-1.953V77.954c.001-1.08-.895-1.954-1.998-1.954zM54 115.092h12V79.908H54v35.184zM45 52H29c-1.105 0-2 .882-2 1.969v63.061c-.001 1.088.895 1.97 1.998 1.97H45c1.105.001 2-.882 2.001-1.969V53.97c0-1.087-.895-1.97-2-1.97zm-14 63.06h12V55.942H31v59.118zM115 91H99c-1.104 0-2 .863-2 1.927v23.145c0 1.065.895 1.928 2 1.928h16c1.104.001 2-.863 2-1.927V92.928c0-1.064-.895-1.928-2-1.928zm-14 23.144h12V94.858h-12v19.286z" />
      <path d="M118.527 44.217a1.933 1.933 0 0 0-.43-.375l-7.867-5.07a1.962 1.962 0 0 0-2.717.59 1.97 1.97 0 0 0-.313 1.067v3.943h-6.814l-15.15-22.779a2.037 2.037 0 0 0-3.272 0L60.378 54.05 38.208 2.197A1.94 1.94 0 0 0 36.37 1a1.966 1.966 0 0 0-1.8 1.25L9.494 66.058H1V70h9.833a1.962 1.962 0 0 0 1.83-1.249L36.476 8.158l21.717 50.79a1.964 1.964 0 0 0 3.443.318L83.6 26.24l14.097 21.197c.365.548.978.878 1.636.878h7.867v3.943c0 1.088.88 1.971 1.965 1.971.47 0 .924-.168 1.282-.475l7.866-6.76c.824-.708.92-1.952.214-2.777zm-7.394 3.755v-3.93l2.615 1.684-2.615 2.246z" />
    </g>
  </svg>
);

export const logout = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g
      fill="none"
      fillRule="evenodd"
      stroke="#005156"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.2"
    >
      <path d="M11 19H7.429C6.639 19 6 18.373 6 17.6V6.4C6 5.627 6.64 5 7.429 5H11M16 15l3-3-3-3M19 12h-9" />
    </g>
  </svg>
);

export const logoHeader = () => (
  <svg
    style={{ margin: "0 auto" }}
    width="160"
    height="30"
    viewBox="0 0 160 33"
    shapeRendering="geometricPrecision"
  >
    <defs>
      <path id="a" d="M0 0h160v33H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="b" fill="#fff">
        <use xlinkHref="#a" />
      </mask>
      <path
        fill="#005394"
        d="M18.021 25.265c-.092.078-.2.16-.316.244h-.002c-.166.12-.35.24-.547.357-1.043.61-2.574 1.2-4.17 1.2l-.219-.008h-.008a5.727 5.727 0 0 1-1.245-.214 5.735 5.735 0 0 1-1.116-.461c-1.745-.965-2.842-2.814-2.842-4.722v-.008h-.002c.002-1.445.543-2.616 1.462-3.416.931-.81 2.255-1.26 3.82-1.266v.005h.02v-.005l5.165.064v8.23zm6.582-15.343c0-2.977-1.313-5.312-3.26-6.903C19.407 1.439 16.845.594 14.316.59h-.018c-2.032.034-3.733.218-5.436.667-1.702.448-3.402 1.164-5.43 2.256l-.24.125.108.247 1.712 3.933.123.286.28-.14c1.56-.776 2.832-1.33 4.042-1.683a12.494 12.494 0 0 1 3.662-.513h.002c1.31 0 2.576.469 3.508 1.257v.002c.92.78 1.52 1.876 1.526 3.153h-.004v1.747h-6.679l-.206.004h-.002c-.81.01-1.605.097-2.368.25-.763.15-1.495.372-2.185.656C3.192 14.291.738 17.43.643 21.783v.01l.002.198a10.038 10.038 0 0 0 1.095 4.378 10.564 10.564 0 0 0 9.131 5.752l.304.008v-.067c.792.005 1.564-.032 2.305-.11.778-.08 1.528-.203 2.249-.364 3.679-.822 6.673-2.632 8.851-4.806l.09-.086v-.122L24.604 9.93v-.007zM71.354 28.344l-1.776-3.666-.13-.266-.266.129-.562.274c-2.428 1.188-4.596 2.244-7.4 2.186h-.001a5.589 5.589 0 0 1-2.037-.41 5.873 5.873 0 0 1-1.48-.893c-2.318-1.887-3.563-5.514-3.563-8.954v-.381a15.83 15.83 0 0 1 .17-2.176c.101-.724.249-1.436.443-2.117.964-3.386 3.023-6.127 5.953-6.303l.074-.004c.282-.017.577-.014.876.002h.002c.296.017.603.046.92.094 1.602.23 3.349.827 5.098 1.649l.25.12.134-.247 1.972-3.669.13-.243-.232-.143-.09-.058h-.002a17.503 17.503 0 0 0-4.635-2.042C61.131.103 56.958.584 53.871 2.74l-.006.004-.005.007v.001c-.595.411-1.15.878-1.666 1.382-.514.51-.992 1.063-1.424 1.649-2.233 3.01-3.412 6.989-3.412 10.96 0 .156.006.332.01.52v.003a18.906 18.906 0 0 0 1.186 6.082c1.83 4.884 5.712 8.791 11.28 8.839v.002a19.83 19.83 0 0 0 6.039-.915c1.874-.593 3.643-1.459 5.376-2.553l.222-.14-.117-.238z"
        mask="url(#b)"
      />
      <path
        fill="#00B3D2"
        d="M32.841 12.181c.074-.347.175-.69.29-1.017.552-1.537 1.54-2.633 3.182-2.633V8.53l.103.002c.286.01.554.056.798.139.242.078.464.196.667.339.987.697 1.551 2.078 1.712 3.668h-6.85c.029-.17.062-.34.098-.496zm11.65 10.112l-.256-.516-.519.247c-1.16.555-2.133 1.015-3.086 1.336-.919.315-1.83.5-2.894.527h-.008a13.5 13.5 0 0 1-.328 0c-1.334-.055-2.532-.682-3.406-1.778-.91-1.138-1.488-2.783-1.543-4.826l-.01-.299H45.442l-.006-.588c-.048-3.697-.662-6.716-2.094-8.832-1.474-2.177-3.776-3.389-7.176-3.389-.21 0-.43.004-.657.022a8.964 8.964 0 0 0-2.582.523 8.03 8.03 0 0 0-2.103 1.162c-3.036 2.338-4.189 6.692-4.225 10.712v.358c.008.531.042 1.062.112 1.577.063.525.16 1.036.28 1.527.606 2.503 1.898 4.718 3.66 6.223l.008.006.127.107.008.005a7.72 7.72 0 0 0 1.328.868c.461.239.952.435 1.461.59 2.482.766 5.333.524 7.62-.128.776-.205 1.479-.481 2.187-.827.697-.345 1.394-.76 2.172-1.26l.438-.28-.227-.462-1.283-2.605z"
        mask="url(#b)"
      />
      <path
        fill="#005394"
        d="M83.183 14.279h1.146l-1.733-3.023c.929-.084 1.61-.815 1.61-1.785 0-1.04-.846-1.856-1.92-1.856h-2.112v6.664h.96v-3.014h.348l1.701 3.014zm-.99-5.912c.578 0 1.054.527 1.054 1.073 0 .62-.424 1.105-1.062 1.105l-1.052-.011V8.367h1.06zm5.744 5.87c.31-.084.559-.218.876-.425l-.267-.547c-.496.238-.824.392-1.299.404-.712.02-1.268-.63-1.228-1.692h2.713c-.021-1.504-.485-2.442-1.817-2.442-1.39 0-1.864 1.307-1.876 2.483-.01.775.302 1.506.807 1.94.567.484 1.442.465 2.09.278zm-.99-4.034c.526 0 .794.515.814 1.115h-1.702c.074-.6.32-1.115.887-1.115zm2.826 2.908c0 .856.629 1.331 1.721 1.229v-.6c-.576-.02-.804-.134-.804-.638V6.904l-.917.3v5.907zm3.806 1.24c.915.02 1.638-.343 2.112-.818l-.009-2.618c0-.908-.795-1.424-1.569-1.424-.627.011-1.051.115-1.681.454l.268.619c.495-.248.805-.35 1.228-.35.432 0 .836.308.836.743v.32H93.67c-.899 0-1.63.567-1.65 1.503 0 .866.713 1.56 1.558 1.58v-.009zm1.163-2.365v1.362c-.132.124-.473.31-.834.31a.91.91 0 0 1-.897-.895c0-.488.362-.786.876-.786l.855.01zm3.683 2.385c.669 0 1.226-.198 1.763-.54l-.279-.575c-.422.206-.783.401-1.27.39-.74-.008-1.152-.866-1.152-1.66-.012-.834.381-1.73 1.071-1.772.33-.02.722.093 1.114.279l.31-.579c-.816-.515-1.806-.556-2.465-.092-.649.454-1 1.309-1 2.164 0 1.146.69 2.374 1.908 2.385zM101 14.28h.958v-4.85l-.967.32.01 4.53zm-.164-6.127c0 .35.28.627.628.627.351 0 .63-.277.63-.627a.61.61 0 0 0-.618-.628.623.623 0 0 0-.63.628h-.01zm4.227 6.208c1.466.011 2.155-1.249 2.155-2.506 0-1.239-.784-2.352-2.134-2.363-1.35-.009-2.145 1.124-2.145 2.363 0 1.257.672 2.497 2.124 2.506zm0-4.136c.857.052 1.134.845 1.134 1.64-.01.866-.193 1.793-1.113 1.815-.846.01-1.124-.95-1.124-1.825 0-.795.208-1.567 1.115-1.63h-.012zm5.866 4.055h.96V10.77c0-.68-.526-1.103-1.092-1.227-.557-.123-1.073-.02-1.445.084-.472.132-.823.361-1.246.669v3.983h.96v-3.777a1.8 1.8 0 0 1 .885-.299c.6-.01.978.32.978.928v3.148zm3.322.072c.918.02 1.64-.343 2.113-.818l-.008-2.618c0-.908-.795-1.424-1.569-1.424-.628.011-1.052.115-1.68.454l.266.619c.497-.248.806-.35 1.23-.35.433 0 .834.308.834.743v.32h-1.092c-.897 0-1.63.567-1.65 1.503 0 .866.711 1.56 1.556 1.58v-.009zm1.164-2.365v1.362a1.36 1.36 0 0 1-.832.31.911.911 0 0 1-.9-.895c0-.488.361-.786.878-.786l.854.01zm6.993 2.293h.968v-3.466c0-.817-.773-1.311-1.485-1.311a2.63 2.63 0 0 0-1.432.403 1.648 1.648 0 0 0-1.103-.414c-.866.022-1.3.29-2 .805v3.983h.959V10.48c.114-.103.37-.257.587-.267.691-.04.969.3.969.928l.008 3.137h.972V10.77c0-.092-.009-.196-.031-.289.66-.463 1.588-.4 1.588.66v3.138zm4.794-.043c.31-.083.557-.217.877-.424l-.269-.547c-.493.238-.824.392-1.297.404-.713.02-1.27-.63-1.227-1.692h2.71c-.02-1.504-.484-2.442-1.815-2.442-1.392 0-1.867 1.307-1.875 2.483-.01.775.298 1.506.802 1.94.568.484 1.446.465 2.094.278zm-.99-4.033c.527 0 .796.515.815 1.115h-1.7c.07-.6.32-1.115.885-1.115zm5.498 4.076h.959V10.77c0-.68-.528-1.103-1.096-1.227-.556-.123-1.072-.02-1.443.084-.475.132-.824.361-1.246.669v3.983h.958v-3.777c.216-.143.545-.288.887-.299.598-.01.98.32.98.928v3.148zm2.164-1.168c0 .847.661 1.323 1.765 1.22v-.59c-.58-.03-.818-.144-.818-.649v-2.805h.818v-.702h-.818V8.038l-.947.34v1.207h-.496v.702h.496v2.824zm4.599 1.25c1.464.01 2.156-1.25 2.156-2.507 0-1.239-.784-2.352-2.135-2.363-1.354-.009-2.145 1.124-2.145 2.363 0 1.257.67 2.497 2.124 2.506zm0-4.137c.855.052 1.134.845 1.134 1.64-.011.866-.197 1.793-1.113 1.815-.847.01-1.123-.95-1.123-1.825 0-.795.206-1.567 1.11-1.63h-.008zm7.889 4.147c.669 0 1.224-.198 1.762-.54l-.278-.575c-.422.206-.784.401-1.27.39-.742-.008-1.153-.866-1.153-1.66-.012-.834.382-1.73 1.072-1.772.33-.02.721.093 1.114.279l.309-.579c-.815-.515-1.805-.556-2.464-.092-.65.454-1 1.309-1 2.164 0 1.146.692 2.374 1.908 2.385zm4.34-.01c1.464.01 2.155-1.25 2.155-2.507 0-1.239-.784-2.352-2.133-2.363-1.351-.009-2.145 1.124-2.145 2.363 0 1.257.668 2.497 2.123 2.506zm0-4.137c.854.052 1.134.845 1.134 1.64-.01.866-.196 1.793-1.112 1.815-.845.01-1.126-.95-1.126-1.825 0-.795.208-1.567 1.114-1.63h-.01zm8.147 4.055h.97v-3.466c0-.817-.774-1.311-1.485-1.311-.58 0-1.001.145-1.437.403a1.638 1.638 0 0 0-1.1-.414c-.867.022-1.301.29-2.001.805v3.983h.958V10.48c.116-.103.37-.257.588-.267.69-.04.968.3.968.928l.012 3.137h.968V10.77c0-.092-.012-.196-.03-.289.659-.463 1.59-.4 1.59.66v3.138zM83.186 25.93h1.143l-1.732-3.024c.929-.082 1.61-.814 1.61-1.781 0-1.045-.846-1.858-1.92-1.858h-2.113v6.663h.96v-3.01h.348l1.704 3.01zm-.99-5.911c.578 0 1.051.526 1.051 1.072 0 .618-.421 1.103-1.06 1.103l-1.052-.011V20.02h1.06zm5.742 5.866c.31-.081.558-.215.877-.421l-.267-.548c-.497.238-.825.392-1.298.403-.713.02-1.27-.63-1.23-1.69h2.713c-.022-1.507-.485-2.445-1.815-2.445-1.39 0-1.866 1.309-1.876 2.485-.014.774.3 1.505.805 1.938.566.488 1.442.468 2.091.278zm-.989-4.03c.527 0 .792.515.814 1.114h-1.7c.071-.599.318-1.115.886-1.115zm4 4.198c.856 0 1.836-.456 1.857-1.498a1.122 1.122 0 0 0-.464-.97c-.248-.185-.537-.295-.815-.411a14.01 14.01 0 0 1-.805-.319c-.206-.102-.31-.215-.31-.403 0-.382.372-.586.775-.586.308 0 .61.09 1.031.328l.36-.627c-.506-.291-.948-.454-1.422-.454-.815 0-1.65.494-1.65 1.432 0 .836.642 1.083 1.278 1.32.134.061.28.123.415.174.287.105.658.218.668.589.012.453-.453.67-.927.67-.383 0-.805-.144-1.185-.444l-.372.61c.485.37 1.02.589 1.566.589zm4.837-.01c1.308-.043 1.886-1.197 1.886-2.352-.01-1.31-.566-2.558-1.877-2.539-1.546.023-2.143.804-2.185.857v5.984l.95.338v-2.6c.37.208.772.331 1.226.322v-.01zm-.113-4.158c.802.033.94 1.002.94 1.776.01.77-.127 1.606-.981 1.658-.392.031-.816-.175-1.073-.328v-2.797c.135-.113.579-.34 1.114-.32v.01zm4.969 4.127c1.464.01 2.156-1.25 2.156-2.507 0-1.239-.786-2.353-2.135-2.362-1.35-.01-2.143 1.123-2.143 2.362 0 1.256.67 2.495 2.122 2.507zm0-4.139c.857.053 1.135.848 1.135 1.641-.011.866-.196 1.794-1.114 1.815-.846.01-1.124-.95-1.124-1.824 0-.794.207-1.568 1.114-1.632h-.011zm5.868 4.057h.958v-3.507c0-.682-.526-1.105-1.092-1.23-.556-.12-1.071-.018-1.443.083-.475.135-.827.362-1.249.672v3.982h.96v-3.776c.214-.145.545-.288.886-.3.598-.011.98.32.98.929v3.147zm3.237.123c.857 0 1.837-.456 1.856-1.498a1.122 1.122 0 0 0-.463-.97c-.248-.185-.536-.295-.814-.411a14.01 14.01 0 0 1-.806-.319c-.206-.102-.308-.215-.308-.403 0-.382.372-.586.772-.586.31 0 .609.09 1.033.328l.363-.627c-.507-.291-.95-.454-1.425-.454-.816 0-1.652.494-1.652 1.432 0 .836.642 1.083 1.281 1.32a6.8 6.8 0 0 0 .411.174c.29.105.66.218.67.589.01.453-.452.67-.927.67-.381 0-.803-.144-1.185-.444l-.374.61c.487.37 1.02.589 1.568.589zm3.96-.053c.918.022 1.64-.341 2.114-.816l-.01-2.62c0-.907-.793-1.421-1.567-1.421-.63.01-1.053.114-1.682.453l.267.619c.497-.247.807-.349 1.228-.349.433 0 .836.308.836.741v.32h-1.094c-.897 0-1.63.567-1.648 1.504 0 .868.71 1.559 1.557 1.581v-.012zm1.166-2.361V25a1.374 1.374 0 0 1-.836.309.91.91 0 0 1-.898-.895c0-.487.362-.785.878-.785l.856.01zm4.135 2.373c1.237.04 1.876-1.229 1.887-2.54 0-1.154-.578-2.308-1.887-2.347a2.37 2.37 0 0 0-1.228.316v-2.897l-.936.32v6.29c.027.052.627.816 2.164.868v-.01zm-.155-4.139c.856.053 1.01.88 1.01 1.65 0 .764-.217 1.754-.958 1.785-.558.031-1-.195-1.125-.299v-2.846c.248-.132.67-.32 1.062-.29h.01zm3.135 4.057h.958v-4.85l-.97.32.012 4.53zm-.164-6.129c0 .354.275.631.628.631.35 0 .628-.277.628-.63a.61.61 0 0 0-.618-.628.625.625 0 0 0-.63.627h-.008zm2.392 4.96c0 .858.628 1.334 1.72 1.229v-.6c-.578-.02-.803-.134-.803-.638v-6.197l-.917.3v5.906zm2.618 1.169h.959v-4.85l-.97.32.01 4.53zm-.165-6.129c0 .354.279.631.627.631a.626.626 0 0 0 .632-.63.61.61 0 0 0-.621-.628.626.626 0 0 0-.629.627h-.01zm4.021 6.211c.847 0 1.57-.322 2.237-.838v-6.64l-.936.32v2.526a3.062 3.062 0 0 0-1.217-.267c-1.321 0-1.938 1.361-1.938 2.463 0 1.062.544 2.436 1.865 2.424l-.01.012zm1.308-3.838v2.785c-.266.175-.68.37-1.081.37-.775 0-1.05-1-1.05-1.721 0-.753.286-1.773 1.103-1.773.39-.012.69.121 1.028.34zm3.394 3.826c.917.022 1.641-.341 2.113-.816l-.009-2.62c0-.907-.794-1.421-1.568-1.421-.628.01-1.053.114-1.68.453l.267.619c.495-.247.805-.349 1.228-.349.432 0 .835.308.835.741v.32h-1.092c-.898 0-1.631.567-1.652 1.504 0 .868.712 1.559 1.558 1.581v-.012zm1.166-2.361V25a1.37 1.37 0 0 1-.836.309.91.91 0 0 1-.897-.895c0-.487.362-.785.876-.785l.857.01zm3.67 2.373c.847 0 1.57-.322 2.237-.838v-6.64l-.936.32v2.526a3.067 3.067 0 0 0-1.219-.267c-1.32 0-1.936 1.361-1.936 2.463 0 1.062.545 2.436 1.864 2.424l-.01.012zm1.309-3.838v2.785c-.269.175-.68.37-1.082.37-.772 0-1.053-1-1.053-1.721 0-.753.29-1.773 1.105-1.773.392-.012.691.121 1.03.34zm4.774 3.711c.31-.081.558-.215.876-.421l-.265-.548c-.497.238-.827.392-1.3.403-.714.02-1.27-.63-1.229-1.69h2.713c-.02-1.507-.485-2.445-1.815-2.445-1.392 0-1.865 1.309-1.877 2.485-.012.774.3 1.505.804 1.938.567.488 1.443.468 2.093.278zm-.99-4.03c.527 0 .793.515.815 1.114h-1.7c.071-.599.318-1.115.884-1.115z"
        mask="url(#b)"
      />
    </g>
  </svg>
);

export const talents = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      fillRule="nonzero"
      d="M12.5 0c.206 0 .385.108.463.296l3.287 6.97 7.32 1.103a.532.532 0 0 1 .257.915l-5.291 5.408 1.258 7.642c.026.215-.051.43-.205.538a.479.479 0 0 1-.308.108c-.077 0-.154 0-.231-.054L12.5 19.32l-6.575 3.633a.551.551 0 0 1-.54-.054.599.599 0 0 1-.205-.538L6.44 14.72 1.149 9.31a.651.651 0 0 1-.13-.565.472.472 0 0 1 .412-.376l7.32-1.104L12.037.296 8.75 7.266 1.43 8.368a.472.472 0 0 0-.41.376.651.651 0 0 0 .128.565l5.29 5.409-1.258 7.642a.599.599 0 0 0 .206.538c.154.108.36.135.54.054L12.5 19.32l6.55 3.606c.077.054.154.054.23.054a.479.479 0 0 0 .309-.108c.154-.107.231-.323.205-.538l-1.258-7.642 5.29-5.409a.532.532 0 0 0-.256-.914l-7.32-1.104L12.963.296A.483.483 0 0 0 12.5 0zm6.062 15.367l1.221 7.407c.048.397-.103.798-.393 1a.946.946 0 0 1-.598.208c-.205 0-.331-.022-.455-.112L12 20.388l-6.396 3.526c-.328.147-.705.106-1.038-.13a1.119 1.119 0 0 1-.371-1.006l1.218-7.384L.26 10.13a1.157 1.157 0 0 1-.225-1.006c.099-.415.414-.7.808-.75l7.082-1.066 3.17-6.71c.155-.376.51-.599.905-.599s.75.223.893.575l3.182 6.734 7.08 1.065c.37.055.703.359.806.735.104.381-.01.799-.28 1.032l-5.12 5.226zm-1.367-.816L22 9.64l-6.65-1.01a.547.547 0 0 1-.389-.3L12 2 9.039 8.33a.502.502 0 0 1-.39.3L2 9.64l4.805 4.911c.13.137.182.328.156.491L5.818 22l5.948-3.274A.728.728 0 0 1 12 18.67c.078 0 .156 0 .234.055L18.182 22l-1.143-6.958a.567.567 0 0 1 .156-.49z"
    />
  </svg>
);

export const candidates = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g fillRule="evenodd" strokeWidth=".5">
      <path d="M12.396 13.235c3.38 0 6.122-2.733 6.122-6.103 0-3.37-2.741-6.085-6.122-6.085-3.379 0-6.12 2.733-6.12 6.085 0 3.351 2.741 6.103 6.12 6.103zm0-10.596c2.48 0 4.507 2.022 4.507 4.493 0 2.471-2.028 4.493-4.507 4.493-2.478 0-4.506-2.022-4.506-4.493 0-2.471 2.028-4.493 4.506-4.493zM1.808 22.766H23.06a.8.8 0 0 0 .808-.805c0-4.213-3.436-7.658-7.68-7.658H8.68C4.454 14.303 1 17.73 1 21.961a.8.8 0 0 0 .808.805zm6.87-6.853h7.511a6.055 6.055 0 0 1 6.009 5.243H2.67a6.07 6.07 0 0 1 6.008-5.243z" />
    </g>
  </svg>
);

export const managers = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g fillRule="evenodd" strokeWidth=".5">
      <path d="M12.396 13.235c3.38 0 6.122-2.733 6.122-6.103 0-3.37-2.741-6.085-6.122-6.085-3.379 0-6.12 2.733-6.12 6.085 0 3.351 2.741 6.103 6.12 6.103zm0-10.596c2.48 0 4.507 2.022 4.507 4.493 0 2.471-2.028 4.493-4.507 4.493-2.478 0-4.506-2.022-4.506-4.493 0-2.471 2.028-4.493 4.506-4.493zM1.808 22.766H23.06a.8.8 0 0 0 .808-.805c0-4.213-3.436-7.658-7.68-7.658H8.68C4.454 14.303 1 17.73 1 21.961a.8.8 0 0 0 .808.805zm6.87-6.853h7.511a6.055 6.055 0 0 1 6.009 5.243H2.67a6.07 6.07 0 0 1 6.008-5.243z" />
    </g>
  </svg>
);

export const trainner = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g fillRule="evenodd">
      <g transform="translate(0 1)">
        <path
          d="M22.523 1.375H1.418a.087.087 0 0 0-.086.086v1.29c0 .047.038.085.086.085h21.105a.086.086 0 0 0 .086-.086V1.461a.086.086 0 0 0-.086-.086z"
          mask="url(#b)"
        />
        <path
          d="M22.523.037H1.418C.636.037 0 .676 0 1.46v1.29c0 .785.636 1.424 1.418 1.424h1.186v11.094c0 .786.636 1.425 1.418 1.425h7.282v3.168L4.79 21.615a.67.67 0 0 0 .344 1.292l6.81-1.832.027.001.027-.001 6.81 1.832a.664.664 0 0 0 .816-.473.67.67 0 0 0-.471-.82l-6.516-1.752v-3.168h7.282c.782 0 1.418-.639 1.418-1.425V4.175h1.187c.781 0 1.417-.64 1.417-1.425V1.461c0-.785-.636-1.424-1.417-1.424zm.086 2.713a.086.086 0 0 1-.086.086H1.418a.086.086 0 0 1-.086-.086V1.461c0-.047.038-.086.086-.086h21.105c.047 0 .086.039.086.086v1.29zm-2.605 12.52a.086.086 0 0 1-.086.086H4.022a.086.086 0 0 1-.086-.087V4.175h16.068v11.094z"
          mask="url(#b)"
        />
      </g>
      <path d="M5.63 15.445a.663.663 0 0 0 .441-.167l4.094-3.632 1.75 1.586c.26.236.658.229.91-.017l4.453-4.34a.671.671 0 0 0 .015-.947.664.664 0 0 0-.942-.014l-4.007 3.905-1.728-1.567a.664.664 0 0 0-.887-.004l-4.54 4.027a.671.671 0 0 0 .441 1.17zM18.31 7.579a.666.666 0 0 0 .666-.67.667.667 0 0 0-1.137-.473.674.674 0 0 0 0 .946.668.668 0 0 0 .472.197z" />
    </g>
  </svg>
);

export const steps = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g fillRule="evenodd">
      <path d="M5.905 15.726H.499a.5.5 0 0 0-.499.499v5.406a.5.5 0 0 0 .5.499h5.405a.499.499 0 0 0 .498-.5v-5.405a.499.499 0 0 0-.498-.5zM14.564 15.726H9.158a.5.5 0 0 0-.499.499v5.406a.5.5 0 0 0 .5.499h5.405a.5.5 0 0 0 .5-.5v-5.405a.5.5 0 0 0-.5-.5zM23.395 15.726h-5.406a.5.5 0 0 0-.5.499v5.406a.5.5 0 0 0 .5.499h5.406a.5.5 0 0 0 .499-.5v-5.405a.5.5 0 0 0-.499-.5zM9.243 6.637h5.406c.277 0 .5-.223.5-.498V.733a.5.5 0 0 0-.5-.5H9.243a.499.499 0 0 0-.497.5V6.14c0 .275.222.498.497.498zM2.372 14h1.024a.499.499 0 0 0 .498-.5v-2.105h7.043v2.111c0 .275.223.498.498.498h1.024a.498.498 0 0 0 .498-.498v-2.111H20v2.108c0 .275.223.497.498.497h1.024a.497.497 0 0 0 .498-.497v-3.63a.498.498 0 0 0-.498-.499h-8.565v-.692a.5.5 0 0 0-.5-.499h-1.022a.499.499 0 0 0-.498.5v.691H2.372a.499.499 0 0 0-.498.499V13.5c0 .275.223.5.498.5z" />
    </g>
  </svg>
);

export const vaga = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      fillRule="nonzero"
      d="M19.2.125H5.8a.619.619 0 0 0-.625.625v22.5c0 .35.275.625.625.625h13.4c.35 0 .625-.275.625-.625V.75A.619.619 0 0 0 19.2.125zm-.7 22.4H8.25L13.15 20c.025 0 .025-.025.05-.025a.76.76 0 0 0 .2-.2l.075-.15c.025-.075.025-.125.025-.175V4.55a.664.664 0 0 0-.35-.575l-4.925-2.5h10.25v21.05h.025zM11.375 12.4v-.825a.475.475 0 1 1 .95 0v.825a.475.475 0 0 1-.475.475c-.275.025-.475-.2-.475-.475z"
    />
  </svg>
);

export const home = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      fillRule="nonzero"
      d="M2 13.111h8.889V2H2v11.111zM2 22h8.889v-6.667H2V22zm11.111 0H22V10.889h-8.889V22zm0-20v6.667H22V2h-8.889z"
    />
  </svg>
);

export const search = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <path
      fill="none"
      fillRule="nonzero"
      d="M6.39 8.41L2.128 3.799C1.838 3.486 2.074 3 2.513 3h10.974c.44 0 .675.486.386.798L9.61 8.411v4.106c0 .356-.395.59-.736.434L6.68 11.947a.48.48 0 0 1-.288-.433V8.41zM3.638 3.965l3.652 3.95c.081.088.126.2.126.317v2.981l1.17.535V8.231c0-.117.045-.229.126-.317l3.652-3.95H3.637z"
    />
  </svg>
);

export const statusOk = (props) => (
  <svg {...props}>
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="table/tbody/col-4" transform="translate(-22.000000, -18.000000)">
        <g
          id="ico/alert/ic-status-check"
          transform="translate(22.000000, 18.000000)"
        >
          <g id="ic_checkmark-on">
            <circle id="Oval" fill="#269400" cx="10" cy="10" r="10" />
            <path
              d="M8.60623429,14.375 C8.43653002,14.375 8.26667818,14.3118268 8.1369651,14.1851919 L5.19488341,11.3138389 C4.93530966,11.060569 4.93501453,10.6496546 5.19414556,10.3959521 C5.4532766,10.1423938 5.87384804,10.1421053 6.13327421,10.3953751 L8.60623429,12.8087944 L14.4917258,7.06493453 C14.751152,6.81137624 15.1715758,6.81180893 15.4308544,7.06551146 C15.6899855,7.31921399 15.6896903,7.73012842 15.4301166,7.98339826 L9.07550347,14.1851919 C8.94579039,14.3118268 8.77593855,14.375 8.60623429,14.375"
              id="checkmark"
              fill="#FFFFFF"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const statusAlert = (props) => (
  <svg {...props}>
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="table/tbody-5/col-4"
        transform="translate(-802.000000, -19.000000)"
      >
        <g
          id="ico/alert/ic-status-alert"
          transform="translate(802.000000, 19.000000)"
        >
          <g id="ic_checkmark-on">
            <circle id="Oval" fill="#FF586D" cx="10" cy="10" r="10" />
            <path
              d="M10.9549878,11.3442822 L9.56812652,11.3442822 L9.30048662,5.83333333 L11.2226277,5.83333333 L10.9549878,11.3442822 Z M10.2615572,14.1666667 L10.2493917,14.1666667 C9.60462287,14.1666667 9.16666667,13.6922141 9.16666667,13.0596107 C9.16666667,12.4026764 9.61678832,11.9525547 10.2615572,11.9525547 C10.906326,11.9525547 11.3321168,12.4026764 11.3442822,13.0596107 C11.3442822,13.6922141 10.9184915,14.1666667 10.2615572,14.1666667 Z"
              id="!"
              fill="#FFFFFF"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const statusWait = (props) => (
  <svg {...props}>
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="table/tbody-3/col-4"
        transform="translate(-802.000000, -19.000000)"
      >
        <g
          id="ico/alert/ic-status-options"
          transform="translate(802.000000, 19.000000)"
        >
          <g id="ic_checkmark-on">
            <circle id="Oval" fill="#EDCE60" cx="10" cy="10" r="10" />
            <g
              id="Group"
              transform="translate(4.166667, 8.333333)"
              fill="#FFFFFF"
            >
              <ellipse
                id="Oval-2"
                cx="1.35877403"
                cy="1.34583334"
                rx="1.35877403"
                ry="1.34583334"
              />
              <ellipse
                id="Oval-2-Copy"
                cx="5.84595351"
                cy="1.34583334"
                rx="1.35877403"
                ry="1.34583334"
              />
              <ellipse
                id="Oval-2-Copy-2"
                cx="10.333133"
                cy="1.34583334"
                rx="1.35877403"
                ry="1.34583334"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const cancel = () => (
  <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="table/tbody/col-4"
        transform="translate(-997.000000, -12.000000)"
        fill="#4A4A4A"
      >
        <g id="Group" transform="translate(997.000000, 12.000000)">
          <g id="ico/ic-cancelar">
            <g id="ico/action/circle/gray" opacity="0.7">
              <path
                d="M12,0 C5.37248437,0 0,5.37248437 0,12 C0,18.6275156 5.37248437,24 12,24 C18.6275156,24 24,18.6275156 24,12 C23.992125,5.3758125 18.6241875,0.007875 12,0 Z M12,22.5 C6.20104688,22.5 1.5,17.7989531 1.5,12 C1.5,6.20104687 6.20104688,1.5 12,1.5 C17.7989531,1.5 22.5,6.20104687 22.5,12 C22.4937656,17.796375 17.796375,22.4937656 12,22.5 Z"
                id="Fill-1"
              />
            </g>
            <g
              id="ico/action/cancel/gray"
              transform="translate(4.000000, 4.000000)"
              opacity="0.696591332"
            >
              <path
                d="M13.7825095,2.22657358 C13.4923363,1.93680973 13.0220702,1.93680973 12.7320828,2.22657358 L8.00462892,6.95038311 L3.27717504,2.22657358 C2.99206255,1.93170662 2.5217964,1.92358804 2.22674838,2.20843435 C1.93165394,2.49314148 1.92352909,2.96304511 2.20859515,3.25786567 C2.21458433,3.2640358 2.2205735,3.27020592 2.22674838,3.27619048 L6.95420226,8 L2.22674838,12.7238095 C1.93165394,13.0085167 1.92352909,13.4784203 2.20859515,13.7734264 C2.49352193,14.0682934 2.96378808,14.076412 3.2588361,13.7915657 C3.26501098,13.7855811 3.27118587,13.7795965 3.27717504,13.7734264 L8.00462892,9.04961689 L12.7320828,13.7734264 C13.0271772,14.0581335 13.4974434,14.0499686 13.7823237,13.755148 C14.0603792,13.4675182 14.0603792,13.011393 13.7823237,12.7238095 L9.05505557,8 L13.7825095,3.27619048 C14.0724968,2.98642663 14.0724968,2.516523 13.7825095,2.22657358 Z"
                id="Fill-4"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const stop = () => (
  <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="table/tbody/col-4"
        transform="translate(-927.000000, -12.000000)"
        fill="#4A4A4A"
      >
        <g id="ico/ic_paralizar" transform="translate(927.000000, 12.000000)">
          <g id="Group-2">
            <g id="ico/action/circle/gray" opacity="0.7">
              <path
                d="M12,0 C5.37248437,0 0,5.37248437 0,12 C0,18.6275156 5.37248437,24 12,24 C18.6275156,24 24,18.6275156 24,12 C23.992125,5.3758125 18.6241875,0.007875 12,0 Z M12,22.5 C6.20104688,22.5 1.5,17.7989531 1.5,12 C1.5,6.20104687 6.20104688,1.5 12,1.5 C17.7989531,1.5 22.5,6.20104687 22.5,12 C22.4937656,17.796375 17.796375,22.4937656 12,22.5 Z"
                id="Fill-1"
              />
            </g>
            <g
              id="ico/action/pause/gray"
              transform="translate(4.000000, 4.000000)"
              opacity="0.697786411"
              stroke="#4A4A4A"
            >
              <g
                id="equal-mathematical-sign"
                transform="translate(4.000000, 2.000000)"
              >
                <path
                  d="M-4.57062005,6.70921986 L5.98918291,6.70921986 C6.38694575,6.70921986 6.70921986,6.39135644 6.70921986,6 C6.70921986,5.60827973 6.38694575,5.29078014 5.98918291,5.29078014 L-4.57062005,5.29078014 C-4.96850604,5.29078014 -5.29078014,5.60827973 -5.29078014,6 C-5.29078014,6.39135644 -4.96850604,6.70921986 -4.57062005,6.70921986 Z"
                  id="Fill-3"
                  strokeWidth="0.5"
                  transform="translate(0.709220, 6.000000) rotate(-90.000000) translate(-0.709220, -6.000000) "
                />
                <path
                  d="M1.10313881,6.70921986 L11.6629418,6.70921986 C12.0607046,6.70921986 12.3829787,6.39135644 12.3829787,6 C12.3829787,5.60827973 12.0607046,5.29078014 11.6629418,5.29078014 L1.10313881,5.29078014 C0.705252827,5.29078014 0.382978723,5.60827973 0.382978723,6 C0.382978723,6.39135644 0.705252827,6.70921986 1.10313881,6.70921986 Z"
                  id="Fill-3-Copy"
                  strokeWidth="0.5"
                  transform="translate(6.382979, 6.000000) rotate(-90.000000) translate(-6.382979, -6.000000) "
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const trilha = () => (
  <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      opacity="0.7"
    >
      <g
        id="table/tbody/col-4"
        transform="translate(-857.000000, -12.000000)"
        fill="#4A4A4A"
      >
        <g id="ico/ic-trilha" transform="translate(857.000000, 12.000000)">
          <g id="ico/action/circle/gray" fillRule="evenodd">
            <path
              d="M12,0 C5.37248437,0 0,5.37248437 0,12 C0,18.6275156 5.37248437,24 12,24 C18.6275156,24 24,18.6275156 24,12 C23.992125,5.3758125 18.6241875,0.007875 12,0 Z M12,22.5 C6.20104688,22.5 1.5,17.7989531 1.5,12 C1.5,6.20104687 6.20104688,1.5 12,1.5 C17.7989531,1.5 22.5,6.20104687 22.5,12 C22.4937656,17.796375 17.796375,22.4937656 12,22.5 Z"
              id="Fill-1"
            />
          </g>
          <g
            id="ico/action/trilha/gray"
            transform="translate(4.000000, 4.000000)"
            fillRule="nonzero"
          >
            <path
              d="M9.10707775,11.4921589 C9.85252011,11.7505078 10.5107507,11.915062 11.4564879,12.2091705 C11.0931635,16.8551085 6.75206434,15.0100659 9.10707775,11.4921589 Z M12.9830027,7.22427519 C12.9340483,5.82929457 12.6912601,3.99939147 10.7573458,4.28612016 C9.85077748,4.52555814 9.18093834,5.53315116 8.86589812,7.27156589 C8.69286863,8.22739147 8.79348525,9.56903101 8.99758713,10.3732713 C9.18394102,10.9400271 9.120563,10.9051899 9.32085791,11.0128217 C10.0960858,11.1895581 10.8635389,11.3852054 11.645067,11.5847054 C12.439008,11.0172984 13.0910724,8.00493798 12.9830027,7.22427519 Z M7.01479893,7.11721318 C7.21873995,6.31286434 7.31935657,4.97122481 7.14640751,4.01550775 C6.83160858,2.27701163 6.16168901,1.26925581 5.25495979,1.02998062 C3.32104558,0.743251938 3.07825737,2.57312791 3.02930295,3.96818992 C2.92123324,4.74871705 3.57337802,7.76126744 4.36739946,8.32856589 C5.14887399,8.12906589 5.91621984,7.9335814 6.69168901,7.75668217 C6.89174263,7.64915891 6.82836461,7.68396899 7.01479893,7.11721318 Z M4.55573727,8.9531938 C4.91892761,13.5990775 9.26002681,11.7540349 6.90506702,8.23618217 C6.15962466,8.49455814 5.50144772,8.65908527 4.55573727,8.9531938 Z"
              id="Shape"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const order = (props) => (
  <svg {...props} width="10px" height="17px" viewBox="0 0 10 7" version="1.1">
    <g
      id="Symbols"
      strokeWidth="1"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g id="ico/action/arrow-down/whitelabel" strokeWidth="2">
        <polyline id="Shape" points="2 2 5 5 8 2" />
      </g>
    </g>
  </svg>
);

export const previousPage = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd" opacity=".7">
      <path
        fill="#4A4A4A"
        d="M12 0C5.372 0 0 5.372 0 12s5.372 12 12 12 12-5.372 12-12C23.992 5.376 18.624.008 12 0zm0 22.5C6.201 22.5 1.5 17.799 1.5 12S6.201 1.5 12 1.5 22.5 6.201 22.5 12c-.006 5.796-4.704 10.494-10.5 10.5z"
      />
      <path
        stroke="#4A4A4A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M13 15l-3-3 3-3"
      />
    </g>
  </svg>
);

export const nextPage = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd" opacity=".7">
      <path
        fill="#4A4A4A"
        d="M12 0C5.372 0 0 5.372 0 12s5.372 12 12 12 12-5.372 12-12C23.992 5.376 18.624.008 12 0zm0 22.5C6.201 22.5 1.5 17.799 1.5 12S6.201 1.5 12 1.5 22.5 6.201 22.5 12c-.006 5.796-4.704 10.494-10.5 10.5z"
      />
      <path
        stroke="#4A4A4A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M11 15l3-3-3-3"
      />
    </g>
  </svg>
);

export const backTenPages = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd" opacity=".7">
      <path
        fill="#4A4A4A"
        d="M12 0C5.372 0 0 5.372 0 12s5.372 12 12 12 12-5.372 12-12C23.992 5.376 18.624.008 12 0zm0 22.5C6.201 22.5 1.5 17.799 1.5 12S6.201 1.5 12 1.5 22.5 6.201 22.5 12c-.006 5.796-4.704 10.494-10.5 10.5z"
      />
      <path
        stroke="#4A4A4A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M12 15l-3-3 3-3, M16 15l-3-3 3-3"
      />
    </g>
  </svg>
);

export const forwardTenPages = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd" opacity=".7">
      <path
        fill="#4A4A4A"
        d="M12 0C5.372 0 0 5.372 0 12s5.372 12 12 12 12-5.372 12-12C23.992 5.376 18.624.008 12 0zm0 22.5C6.201 22.5 1.5 17.799 1.5 12S6.201 1.5 12 1.5 22.5 6.201 22.5 12c-.006 5.796-4.704 10.494-10.5 10.5z"
      />
      <path
        stroke="#4A4A4A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M10 15l3-3-3-3, M14 15l3-3-3-3"
      />
    </g>
  </svg>
);

export const show = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill="#4A4A4A"
        d="M12 0C5.372 0 0 5.372 0 12s5.372 12 12 12 12-5.372 12-12C23.992 5.376 18.624.008 12 0zm0 22.5C6.201 22.5 1.5 17.799 1.5 12S6.201 1.5 12 1.5 22.5 6.201 22.5 12c-.006 5.796-4.704 10.494-10.5 10.5z"
        opacity=".7"
      />
      <path
        fill="#818181"
        fillRule="nonzero"
        d="M18 12l-.124.232c-.02.039-.518.962-1.484 1.887-1.286 1.23-2.8 1.881-4.38 1.881-1.579 0-3.097-.65-4.39-1.88a8.385 8.385 0 0 1-1.496-1.886L6 12l.126-.234c.021-.039.524-.962 1.496-1.886C8.915 8.65 10.433 8 12.012 8c1.58 0 3.094.65 4.38 1.88a8.318 8.318 0 0 1 1.484 1.888L18 12zm-1.672.025l.018-.025a7.351 7.351 0 0 0-.936-1.093c-1.03-.986-2.197-1.487-3.398-1.487s-2.374.502-3.411 1.489A7.43 7.43 0 0 0 7.659 12l.015.022c.26.364.57.73.927 1.07 1.037.986 2.21 1.488 3.411 1.488s2.368-.501 3.398-1.486a7.35 7.35 0 0 0 .918-1.07zM12 10c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zm0 1.42a.582.582 0 0 0-.58.58c0 .319.261.58.58.58.319 0 .58-.261.58-.58a.582.582 0 0 0-.58-.58z"
      />
    </g>
  </svg>
);

export const alert = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g fill="none" fillRule="evenodd">
      <circle cx="8" cy="8" r="8" fill="#CFCFCF" />
      <path
        fill="#FFF"
        d="M8.764 9.075h-1.11L7.44 4.667h1.538l-.214 4.408zm-.555 2.258H8.2c-.515 0-.866-.38-.866-.885 0-.526.36-.886.876-.886s.857.36.866.886c0 .506-.34.885-.866.885z"
      />
    </g>
  </svg>
);
export const graficoIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="82"
    height="82"
    viewBox="0 0 82 82"
  >
    <g fill="none" fillRule="evenodd">
      <g transform="translate(2 2)">
        <circle cx="39" cy="39" r="39" stroke="#17B3D2" strokeWidth="2.5" />
        <path
          fill="#17B3D2"
          fillRule="nonzero"
          stroke="#F0F0F0"
          strokeWidth=".3"
          d="M46.897 22.323a1.28 1.28 0 0 0-1.137 1.285V53.26c0 .71.57 1.285 1.273 1.285h8.54c.458.007.885-.237 1.116-.637.232-.4.232-.896 0-1.296a1.271 1.271 0 0 0-1.119-.637h-7.114l-.15-.15V25.043l.15-.15h5.691l.15.15v22.48c-.006.464.235.895.632 1.128.396.234.886.234 1.282 0 .397-.233.638-.664.632-1.13V23.608c0-.71-.57-1.285-1.273-1.285h-8.545a1.261 1.261 0 0 0-.128 0zM34.092 28.54a1.28 1.28 0 0 0-1.137 1.285V53.26c0 .71.57 1.285 1.273 1.285h8.537c.702 0 1.273-.575 1.273-1.285V29.825c0-.71-.57-1.284-1.273-1.284H34.22a1.261 1.261 0 0 0-.128 0zm1.559 2.57h5.691l.15.15v20.565l-.15.15h-5.691l-.15-.15V31.26l.15-.15zm-9.96.778c-2.52 0-4.592 2.091-4.592 4.633 0 1.408.644 2.726 1.723 3.605l.163.133-.179.11a5.625 5.625 0 0 0-2.656 4.776v8.115c0 .71.57 1.285 1.273 1.285h8.537c.702 0 1.272-.575 1.272-1.285v-8.115a5.625 5.625 0 0 0-2.656-4.775l-.178-.111.163-.133a4.656 4.656 0 0 0 1.723-3.605c0-2.542-2.073-4.633-4.593-4.633zm0 2.57c1.148 0 2.047.907 2.047 2.063 0 1.156-.9 2.063-2.047 2.063-1.147 0-2.047-.907-2.047-2.063 0-1.156.9-2.063 2.047-2.063zm0 7.652c1.684 0 2.996 1.326 2.996 3.035v6.68l-.15.15h-5.691l-.15-.15v-6.68c0-1.709 1.311-3.035 2.995-3.035z"
        />
      </g>
      <g transform="translate(54 54)">
        <circle cx="13" cy="13" r="13" fill="#17B3D2" />
        <path
          fill="#FFF"
          d="M13.546 12.086h5.062c.216 0 .392.176.392.393v.93a.392.392 0 0 1-.392.392h-5.062v4.807a.392.392 0 0 1-.393.392h-.419a.392.392 0 0 1-.392-.392V13.8h-4.95A.392.392 0 0 1 7 13.409v-.93c0-.217.176-.393.392-.393h4.95V7.392c0-.216.175-.392.392-.392h.42c.216 0 .392.176.392.392v4.694z"
        />
      </g>
    </g>
  </svg>
);

export const paperIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="79"
    height="79"
    viewBox="0 0 79 79"
  >
    <g fill="none" fillRule="evenodd">
      <circle
        cx="39.5"
        cy="39.5"
        r="38.25"
        stroke="#17B3D2"
        strokeWidth="2.5"
      />
      <g fill="#17B3D2" fillRule="nonzero">
        <path d="M27 53c0 2.21 1.816 4 4.056 4h18.657c2.24 0 4.056-1.79 4.056-4V32.1a.993.993 0 0 0-.304-.7l-10.9-10.15a.971.971 0 0 0-.66-.25h-10.85C28.816 21 27 22.79 27 25v28zm15.92-28.7l7.3 6.8h-6.286a.97.97 0 0 1-.734-.277.943.943 0 0 1-.28-.723v-5.8zm-13.892.7c0-1.105.908-2 2.028-2h9.836v7.1c-.014.8.302 1.57.875 2.136a3.013 3.013 0 0 0 2.167.864h7.807V53c0 1.105-.908 2-2.028 2H31.056c-1.12 0-2.028-.895-2.028-2V25z" />
        <path d="M31.72 44.077h16.405c.568 0 1.029-.413 1.029-.923s-.46-.923-1.029-.923H31.721c-.568 0-1.029.413-1.029.923s.46.923 1.029.923zM31.752 38.538h8.957c.586 0 1.06-.413 1.06-.923s-.474-.923-1.06-.923h-8.957c-.585 0-1.06.414-1.06.923 0 .51.475.923 1.06.923zM31.72 49.615h16.405c.568 0 1.029-.413 1.029-.923s-.46-.923-1.029-.923H31.721c-.568 0-1.029.414-1.029.923 0 .51.46.923 1.029.923z" />
      </g>
      <g>
        <g transform="translate(52 52)">
          <circle cx="13" cy="13" r="13" fill="#17B3D2" />
          <path
            fill="#FFF"
            d="M13.546 12.086h5.062c.216 0 .392.176.392.393v.93a.392.392 0 0 1-.392.392h-5.062v4.807a.392.392 0 0 1-.393.392h-.419a.392.392 0 0 1-.392-.392V13.8h-4.95A.392.392 0 0 1 7 13.409v-.93c0-.217.176-.393.392-.393h4.95V7.392c0-.216.175-.392.392-.392h.42c.216 0 .392.176.392.392v4.694z"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const avatarIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="79"
    height="79"
    viewBox="0 0 79 79"
  >
    <g fill="none" fillRule="evenodd">
      <circle
        cx="39.5"
        cy="39.5"
        r="38.25"
        stroke="#17B3D2"
        strokeWidth="2.5"
      />
      <g fill="#17B3D2">
        <path d="M39.61 41.353c4.927 0 8.923-4.1 8.923-9.155s-3.996-9.128-8.922-9.128-8.921 4.1-8.921 9.128c0 5.027 3.995 9.155 8.92 9.155zm0-15.895c3.614 0 6.57 3.033 6.57 6.74 0 3.707-2.956 6.74-6.57 6.74-3.611 0-6.567-3.033-6.567-6.74 0-3.707 2.956-6.74 6.568-6.74zM24.177 55.65h30.978c.657 0 1.177-.534 1.177-1.21 0-6.318-5.008-11.485-11.193-11.485H34.192C28.035 42.955 23 48.095 23 54.44c0 .675.52 1.208 1.177 1.208zm10.015-10.28H45.14c4.488 0 8.183 3.427 8.757 7.864h-28.46c.575-4.41 4.27-7.864 8.756-7.864z" />
      </g>
      <g>
        <g transform="translate(52 52)">
          <circle id="teste" cx="13" cy="13" r="13" fill="#17B3D2" />
          <path
            fill="#FFF"
            d="M13.546 12.086h5.062c.216 0 .392.176.392.393v.93a.392.392 0 0 1-.392.392h-5.062v4.807a.392.392 0 0 1-.393.392h-.419a.392.392 0 0 1-.392-.392V13.8h-4.95A.392.392 0 0 1 7 13.409v-.93c0-.217.176-.393.392-.393h4.95V7.392c0-.216.175-.392.392-.392h.42c.216 0 .392.176.392.392v4.694z"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const medalIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="82"
    height="82"
    viewBox="0 0 82 82"
  >
    <g fill="none" fillRule="evenodd">
      <g stroke="#17B3D2" strokeWidth="2.5" transform="translate(2 2)">
        <circle cx="39" cy="39" r="39" />
        <g
          strokeLinecap="round"
          strokeLinejoin="round"
          transform="translate(27 20)"
        >
          <ellipse cx="11.688" cy="11.479" rx="11.164" ry="11.362" />
          <path d="M17.27 21.307v18.576l-5.582-5.68-5.583 5.68V21.307" />
        </g>
      </g>
      <g transform="translate(54 54)">
        <circle cx="13" cy="13" r="13" fill="#17B3D2" />
        <path
          fill="#FFF"
          d="M13.546 12.086h5.062c.216 0 .392.176.392.393v.93a.392.392 0 0 1-.392.392h-5.062v4.807a.392.392 0 0 1-.393.392h-.419a.392.392 0 0 1-.392-.392V13.8h-4.95A.392.392 0 0 1 7 13.409v-.93c0-.217.176-.393.392-.393h4.95V7.392c0-.216.175-.392.392-.392h.42c.216 0 .392.176.392.392v4.694z"
        />
      </g>
    </g>
  </svg>
);

export const arrowIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="82"
    height="82"
    viewBox="0 0 82 82"
  >
    <g fill="none" fillRule="evenodd">
      <g transform="translate(2 2)">
        <circle cx="39" cy="39" r="39" stroke="#17B3D2" strokeWidth="2.5" />
        <path
          fill="#17B3D2"
          fillRule="nonzero"
          stroke="#F0F0F0"
          strokeWidth="1.2"
          d="M53.523 26.655c7.43 7.534 7.43 19.803 0 27.382-7.43 7.578-19.533 7.533-27.008 0-6.23-6.316-7.252-15.924-3.026-23.322l3.16 3.203c-2.581 5.548-1.647 12.45 2.892 17.051 5.784 5.865 15.172 5.865 20.912 0 5.784-5.864 5.784-15.382 0-21.201a14.606 14.606 0 0 0-19.444-1.353l2.803 2.842c4.227-2.978 10.145-2.572 13.882 1.263 4.227 4.285 4.227 11.322 0 15.607-4.227 4.286-11.168 4.286-15.395 0-2.98-3.022-3.87-7.397-2.67-11.187l3.783 3.835a6.65 6.65 0 0 0 1.913 4.285 6.543 6.543 0 0 0 9.344 0c2.58-2.616 2.58-6.857 0-9.473a6.504 6.504 0 0 0-7.742-1.173l2.98 3.023c.757-.046 1.514.27 2.092.857a2.942 2.942 0 0 1 0 4.105 2.846 2.846 0 0 1-4.049 0c-.578-.587-.845-1.354-.845-2.12l-2.937-3.068-3.114-3.158-2.804-2.842-3.07-3.112-2.536-2.571-1.78.315-4.494-4.556 4.138-.767.712-4.15 4.494 4.556-.311 1.805 2.536 2.571c7.52-6.18 18.599-5.729 25.584 1.353z"
        />
      </g>
      <g transform="translate(54 54)">
        <circle cx="13" cy="13" r="13" fill="#17B3D2" />
        <path
          fill="#FFF"
          d="M13.546 12.086h5.062c.216 0 .392.176.392.393v.93a.392.392 0 0 1-.392.392h-5.062v4.807a.392.392 0 0 1-.393.392h-.419a.392.392 0 0 1-.392-.392V13.8h-4.95A.392.392 0 0 1 7 13.409v-.93c0-.217.176-.393.392-.393h4.95V7.392c0-.216.175-.392.392-.392h.42c.216 0 .392.176.392.392v4.694z"
        />
      </g>
    </g>
  </svg>
);

export const paper = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="79"
    height="79"
    viewBox="0 0 79 79"
  >
    <g fill="none" fillRule="evenodd">
      <circle
        cx="39.5"
        cy="39.5"
        r="38.25"
        stroke="#005394"
        strokeWidth="2.5"
      />
      <g fill="#005394" fillRule="nonzero">
        <path d="M27 53c0 2.21 1.816 4 4.056 4h18.657c2.24 0 4.056-1.79 4.056-4V32.1a.993.993 0 0 0-.304-.7l-10.9-10.15a.971.971 0 0 0-.66-.25h-10.85C28.816 21 27 22.79 27 25v28zm15.92-28.7l7.3 6.8h-6.286a.97.97 0 0 1-.734-.277.943.943 0 0 1-.28-.723v-5.8zm-13.892.7c0-1.105.908-2 2.028-2h9.836v7.1c-.014.8.302 1.57.875 2.136a3.013 3.013 0 0 0 2.167.864h7.807V53c0 1.105-.908 2-2.028 2H31.056c-1.12 0-2.028-.895-2.028-2V25z" />
        <path d="M31.72 44.077h16.405c.568 0 1.029-.413 1.029-.923s-.46-.923-1.029-.923H31.721c-.568 0-1.029.413-1.029.923s.46.923 1.029.923zM31.752 38.538h8.957c.586 0 1.06-.413 1.06-.923s-.474-.923-1.06-.923h-8.957c-.585 0-1.06.414-1.06.923 0 .51.475.923 1.06.923zM31.72 49.615h16.405c.568 0 1.029-.413 1.029-.923s-.46-.923-1.029-.923H31.721c-.568 0-1.029.414-1.029.923 0 .51.46.923 1.029.923z" />
      </g>
    </g>
  </svg>
);

export const filterIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="nonzero"
      d="M6.39 8.41L2.128 3.799C1.838 3.486 2.074 3 2.513 3h10.974c.44 0 .675.486.386.798L9.61 8.411v4.106c0 .356-.395.59-.736.434L6.68 11.947a.48.48 0 0 1-.288-.433V8.41zM3.638 3.965l3.652 3.95c.081.088.126.2.126.317v2.981l1.17.535V8.231c0-.117.045-.229.126-.317l3.652-3.95H3.637z"
    />
  </svg>
);

export const carrier = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="82"
    height="82"
    viewBox="0 0 82 82"
  >
    <g fill="none" fillRule="evenodd" transform="translate(2 2)">
      <circle cx="39" cy="39" r="39" stroke="#005394" strokeWidth="2.5" />
      <path
        fill="#005394"
        fillRule="nonzero"
        stroke="#F0F0F0"
        strokeWidth=".3"
        d="M46.897 22.323a1.28 1.28 0 0 0-1.137 1.285V53.26c0 .71.57 1.285 1.273 1.285h8.54c.458.007.885-.237 1.116-.637.232-.4.232-.896 0-1.296a1.271 1.271 0 0 0-1.119-.637h-7.114l-.15-.15V25.043l.15-.15h5.691l.15.15v22.48c-.006.464.235.895.632 1.128.396.234.886.234 1.282 0 .397-.233.638-.664.632-1.13V23.608c0-.71-.57-1.285-1.273-1.285h-8.545a1.261 1.261 0 0 0-.128 0zM34.092 28.54a1.28 1.28 0 0 0-1.137 1.285V53.26c0 .71.57 1.285 1.273 1.285h8.537c.702 0 1.273-.575 1.273-1.285V29.825c0-.71-.57-1.284-1.273-1.284H34.22a1.261 1.261 0 0 0-.128 0zm1.559 2.57h5.691l.15.15v20.565l-.15.15h-5.691l-.15-.15V31.26l.15-.15zm-9.96.778c-2.52 0-4.592 2.091-4.592 4.633 0 1.408.644 2.726 1.723 3.605l.163.133-.179.11a5.625 5.625 0 0 0-2.656 4.776v8.115c0 .71.57 1.285 1.273 1.285h8.537c.702 0 1.272-.575 1.272-1.285v-8.115a5.625 5.625 0 0 0-2.656-4.775l-.178-.111.163-.133a4.656 4.656 0 0 0 1.723-3.605c0-2.542-2.073-4.633-4.593-4.633zm0 2.57c1.148 0 2.047.907 2.047 2.063 0 1.156-.9 2.063-2.047 2.063-1.147 0-2.047-.907-2.047-2.063 0-1.156.9-2.063 2.047-2.063zm0 7.652c1.684 0 2.996 1.326 2.996 3.035v6.68l-.15.15h-5.691l-.15-.15v-6.68c0-1.709 1.311-3.035 2.995-3.035z"
      />
    </g>
  </svg>
);

export const formation = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="82"
    height="82"
    viewBox="0 0 82 82"
  >
    <g
      fill="none"
      fillRule="evenodd"
      stroke="#005394"
      strokeWidth="2.5"
      transform="translate(2 2)"
    >
      <circle cx="39" cy="39" r="39" />
      <g
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(27 20)"
      >
        <ellipse cx="11.688" cy="11.479" rx="11.164" ry="11.362" />
        <path d="M17.27 21.307v18.576l-5.582-5.68-5.583 5.68V21.307" />
      </g>
    </g>
  </svg>
);

export const arrowDown = () => (
  <svg
    width="8px"
    height="6px"
    viewBox="0 0 8 6"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Elementos"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g
        id="elements/header/user"
        transform="translate(-173.000000, -18.000000)"
        stroke="#17B3D2"
        strokeWidth="1.3"
      >
        <g
          id="ico/action/arrow-down/primary"
          transform="translate(172.000000, 16.000000)"
        >
          <polyline id="Shape" points="2 3.5 5 6.5 8 3.5" />
        </g>
      </g>
    </g>
  </svg>
);

export const goal = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="85"
    height="85"
    viewBox="0 0 85 85"
  >
    <g fill="none" fillRule="evenodd" transform="translate(2 2)">
      <circle cx="40.5" cy="40.5" r="40.5" stroke="#005394" strokeWidth="2.5" />
      <path
        fill="#005394"
        fillRule="nonzero"
        stroke="#F0F0F0"
        strokeWidth="1.2"
        d="M55.582 27.68c7.716 7.824 7.716 20.565 0 28.435-7.717 7.87-20.285 7.823-28.047 0-6.469-6.558-7.532-16.536-3.142-24.218l3.28 3.326c-2.68 5.761-1.71 12.929 3.004 17.707 6.007 6.09 15.756 6.09 21.717 0 6.006-6.09 6.006-15.974 0-22.017a15.168 15.168 0 0 0-20.192-1.406l2.91 2.952c4.39-3.092 10.536-2.67 14.417 1.311 4.39 4.45 4.39 11.758 0 16.209-4.39 4.45-11.598 4.45-15.987 0-3.096-3.14-4.02-7.683-2.773-11.618l3.928 3.982a6.906 6.906 0 0 0 1.987 4.45 6.794 6.794 0 0 0 9.703 0c2.68-2.717 2.68-7.12 0-9.837a6.754 6.754 0 0 0-8.04-1.218l3.096 3.138c.785-.046 1.57.281 2.171.89a3.055 3.055 0 0 1 0 4.263 2.955 2.955 0 0 1-4.204 0c-.6-.609-.878-1.405-.878-2.201l-3.05-3.186-3.234-3.279-2.911-2.951-3.188-3.232-2.634-2.67-1.848.327L17 22.106l4.297-.796.74-4.31 4.666 4.731-.323 1.874 2.633 2.67c7.81-6.417 19.314-5.949 26.569 1.406z"
      />
    </g>
  </svg>
);

export const aboutYou = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ? props.width : "79"}
    height={props.height ? props.height : "79"}
    viewBox="0 0 79 79"
  >
    <g fill="none" fillRule="evenodd">
      <circle
        cx="39.5"
        cy="39.5"
        r="38.25"
        stroke="#005394"
        strokeWidth="2.5"
      />
      <g fill="#005394">
        <path d="M39.61 41.353c4.927 0 8.923-4.1 8.923-9.155s-3.996-9.128-8.922-9.128-8.921 4.1-8.921 9.128c0 5.027 3.995 9.155 8.92 9.155zm0-15.895c3.614 0 6.57 3.033 6.57 6.74 0 3.707-2.956 6.74-6.57 6.74-3.611 0-6.567-3.033-6.567-6.74 0-3.707 2.956-6.74 6.568-6.74zM24.177 55.65h30.978c.657 0 1.177-.534 1.177-1.21 0-6.318-5.008-11.485-11.193-11.485H34.192C28.035 42.955 23 48.095 23 54.44c0 .675.52 1.208 1.177 1.208zm10.015-10.28H45.14c4.488 0 8.183 3.427 8.757 7.864h-28.46c.575-4.41 4.27-7.864 8.756-7.864z" />
      </g>
    </g>
  </svg>
);

export const LoadAnimation = () => (
  <svg
    className="lds-typing"
    width="100px"
    height="100px"
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMid"
  >
    <circle cx="27.5" cy="39.2104" r="5" fill="#000">
      <animate
        attributeName="cy"
        calcMode="spline"
        keySplines="0 0.5 0.5 1;0.5 0 1 0.5;0.5 0.5 0.5 0.5"
        repeatCount="indefinite"
        values="62.5;37.5;62.5;62.5"
        keyTimes="0;0.25;0.5;1"
        dur="1s"
        begin="-0.5s"
      />
    </circle>
    <circle cx="42.5" cy="37.9772" r="5" fill="#005156">
      <animate
        attributeName="cy"
        calcMode="spline"
        keySplines="0 0.5 0.5 1;0.5 0 1 0.5;0.5 0.5 0.5 0.5"
        repeatCount="indefinite"
        values="62.5;37.5;62.5;62.5"
        keyTimes="0;0.25;0.5;1"
        dur="1s"
        begin="-0.375s"
      />
    </circle>
    <circle cx="57.5" cy="44.9219" r="5" fill="#000">
      <animate
        attributeName="cy"
        calcMode="spline"
        keySplines="0 0.5 0.5 1;0.5 0 1 0.5;0.5 0.5 0.5 0.5"
        repeatCount="indefinite"
        values="62.5;37.5;62.5;62.5"
        keyTimes="0;0.25;0.5;1"
        dur="1s"
        begin="-0.25s"
      />
    </circle>
    <circle cx="72.5" cy="62.5" r="5" fill="#005156">
      <animate
        attributeName="cy"
        calcMode="spline"
        keySplines="0 0.5 0.5 1;0.5 0 1 0.5;0.5 0.5 0.5 0.5"
        repeatCount="indefinite"
        values="62.5;37.5;62.5;62.5"
        keyTimes="0;0.25;0.5;1"
        dur="1s"
        begin="-0.125s"
      />
    </circle>
  </svg>
);

export const disabled = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 16 16">
    <g fill="none" fillRule="evenodd">
      <circle cx="8" cy="8" r="8" fill="#858585" />
      <g fill="#FFF" transform="translate(3.333 6.667)">
        <ellipse cx="1.087" cy="1.077" rx="1.087" ry="1.077" />
        <ellipse cx="4.677" cy="1.077" rx="1.087" ry="1.077" />
        <ellipse cx="8.267" cy="1.077" rx="1.087" ry="1.077" />
      </g>
    </g>
  </svg>
);
